// UI + domain translations for DE / IT / FR / EN
export const LANGS = [
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
];

const T = {
  it: {
    tagline: "L'Ecosistema Digitale per il Professionista",
    bestMatch: "Miglior Match",
    techEquivalent: "Equivalente Tecnico",
    matchInfo: "Questi prodotti sono stati abbinati per caratteristiche tecniche simili (Sottocategoria e Classe).",
    cookieTitle: "Rispettiamo la tua privacy",
    cookieText: "Usiamo cookie tecnici necessari al funzionamento del sito e, con il tuo consenso, cookie per statistiche e per migliorare l'esperienza.",
    cookieAccept: "Accetta tutti",
    cookieReject: "Solo necessari",
    contactTitle: "Hai domande o vuoi collaborare?",
    contactSubtitle: "Scrivici, ti risponderemo al più presto.",
    contactName: "Nome",
    contactEmail: "La tua email",
    contactCompany: "Azienda (facoltativo)",
    contactMessage: "Messaggio",
    contactSend: "Invia messaggio",
    contactSending: "Invio...",
    contactSuccess: "Messaggio inviato! Ti risponderemo presto.",
    contactError: "Invio non riuscito. Riprova.",
    contactCta: "Contattaci",
    subtitle: "Scegli due prodotti e scopri quale conviene davvero, resa e costi alla mano.",
    compare: "Confronta",
    catalog: "Catalogo",
    datasheetMissing: "Scheda tecnica mancante",
    category: "Area",
    subcategory: "Sottocategoria",
    brand: "Marca",
    product: "Prodotto",
    selectPlaceholder: "Seleziona…",
    filtersTitle: "Filtri rapidi",
    filtersHint: "Tocca i filtri per restringere la lista. La scelta manuale resta sempre disponibile.",
    fInterno: "Interno",
    fEsterno: "Esterno",
    fClasse: "Classe S1/S2",
    fRapido: "Rapido",
    fRapidaAsc: "Rapida asciugatura",
    fPompabile: "Pompabile",
    fUV: "Resistente UV",
    fBicomp: "Bicomponente",
    fFlex: "Flessibile",
    fThickness: "Spessore (mm)",
    fResults: "prodotti",
    noMatch: "Nessun prodotto corrisponde ai criteri selezionati",
    clearFilters: "Azzera filtri",
    productA: "Prodotto A",
    productB: "Prodotto B",
    addMissing: "Prodotto mancante? Carica la scheda tecnica",
    addMissingHint: "L'AI legge il PDF ed estrae i dati automaticamente.",
    // upload
    uploadTitle: "Carica scheda tecnica",
    fabAddDatasheet: "Aggiungi Scheda Tecnica",
    multiUseLabel: "Usi multipli rilevati",
    removeUse: "Rimuovi questo uso",
    uploadHint: "L'IA legge il PDF o l'immagine (in qualsiasi lingua) ed estrae i dati automaticamente. Se un dato non è nella scheda, Gemini prova a dedurlo dalle sue conoscenze del prodotto (da verificare).",
    uploadDrop: "Trascina qui il file o clicca per selezionare",
    uploadFormats: "PDF, PNG, JPG",
    extracting: "Lettura della scheda in corso con Gemini…",
    reviewExtracted: "Verifica e correggi i dati estratti",
    saveProduct: "Salva prodotto",
    cancel: "Annulla",
    fileRequired: "Seleziona prima un file",
    extractError: "Estrazione non riuscita. Riprova con un file più leggibile.",
    savedOk: "Prodotto salvato nel catalogo",
    aiEstimatedHint: "Alcuni valori evidenziati sono STIME INDICATIVE (non presenti nella scheda, dedotti da fonti/prezzi di mercato online): verificali.",
    dupSimilar: "Prodotto SIMILE già presente:",
    dupWarn: "Esiste già un prodotto simile:",
    autoCategory: "Categoria assegnata automaticamente",
    editCategoryHint: "modificabile se necessario",
    chooseForQuote: "Scegli questo per offerta",
    // comparison
    comparison: "Confronto",
    winner: "Migliore",
    difference: "Differenza",
    savings: "Risparmio",
    saveOf: "risparmi",
    parameters: "Parametri di calcolo",
    metratura: "Superficie da posare",
    laborSection: "Costi di posa (opzionali · default 0)",
    spessore2mani: "Spessore 2 mani",
    pricePerKg: "Prezzo al kg",
    useForQuote: "Usa questo prodotto",
    costBreakdown: "Dettaglio costi",
    quoteRecapTitle: "Prodotto selezionato",
    consumptionTitle: "Dettagli consumo",
    quoteEmptyTitle: "Nessun prodotto selezionato",
    quoteEmptyBody: "Seleziona un prodotto qui sopra per calcolare le quantità in base ai m².",
    goToComparator: "Vai al Comparatore",
    marketPriceHint: "Modifica il prezzo in base al mercato attuale.",
    consumption: "Consumo",
    bagWeight: "Peso confezione",
    advanced: "Parametri di cantiere",
    salary: "Manodopera",
    transportMin: "Spostamento sacchi",
    mixingMin: "Miscelazione",
    palletMin: "Spostamento a magazzino",
    bagsPerPallet: "Sacchi per bancale",
    productCost: "Costo del prodotto",
    transportCost: "Spostamento sacchi",
    mixingCost: "Miscelazione",
    palletCost: "Spostamento a magazzino",
    costComposition: "Composizione del costo",
    descMetratura: "Superficie totale da rivestire.",
    descSalary: "Prezzo medio orario che un'azienda paga un proprio operaio.",
    descTransport: "Tempo per portare ogni sacco fino al punto di posa.",
    descMixing: "Tempo per impastare ogni sacco.",
    descPallet: "Tempo per movimentare i bancali dal magazzino.",
    readonlyHint: "Dati fissi del prodotto (non modificabili)",
    trowel: "Spatola",
    trowelDesc: "Denti della spatola: modifica il consumo (base 6 mm).",
    tileA: "Lato A piastrella",
    tileB: "Lato B piastrella",
    tileThickness: "Spessore piastrella",
    jointWidth: "Larghezza fuga",
    groutDesc: "Geometria piastrella e fuga: calcola i kg di stucco necessari.",
    groutJoint: "fuga",
    interpolated: "interpolato",
    unitCm: "Centimetri",
    navQuote: "Scegli Prodotto",
    quoteTitle: "Scegli il prodotto",
    quoteSubtitle: "Sai già quale prodotto usare? Selezionalo e calcola le quantità in base ai m². Stesse informazioni del paragone, senza grafici.",
    shareTitle: "Condividi risultati / Invia ordine",
    shareHint: "Compila i dati: scarichi il PDF e, se inserisci l'email del destinatario, riceverà una copia.",
    fCompany: "Nome impresa / artigiano *",
    fProject: "Nome progetto / cantiere *",
    fCityZip: "Città o CAP del cantiere *",
    fRecipient: "Email destinatario (cliente/rivenditore) — opzionale",
    fNotes: "Note aggiuntive (opzionale)",
    btnSend: "Invia e scarica PDF",
    shareRequired: "Compila impresa, progetto e città/CAP.",
    disclaimerShort: "Dati inseriti dagli utenti per gli utenti. Nessuna responsabilità per errori di calcolo.",
    copyright: "© 2026 METEROX. Proprietà intellettuale esclusiva. Tutti i diritti riservati.",
    dsView: "Vedi/Scarica",
    dsReplace: "Sostituisci",
    dsAttach: "Allega scheda",
    navLeads: "Lead",
    leadsTitle: "Lead & Preventivi raccolti",
    leadsEmpty: "Nessun lead ancora.",
    thDate: "Data",
    thCompany: "Impresa",
    thProject: "Progetto",
    thCity: "Città/CAP",
    thQty: "Quantità",
    thEmail: "Email dest.",
    viewLeads: "Lead",
    viewContacts: "Messaggi",
    contactsTitle: "Messaggi ricevuti",
    contactsEmpty: "Nessun messaggio ricevuto.",
    viewProducts: "Prodotti",
    toastSent: "Inviato e PDF scaricato",
    toastDownloaded: "PDF scaricato",
    markup: "Ricarico Artigiano (%)",
    clientPrice: "Prezzo per il Cliente",
    quoteExportTitle: "Esporta Preventivo PDF",
    quoteExportHint: "Inserisci i dati del progetto per generare il PDF del preventivo.",
    projectName: "Nome Progetto",
    zip: "CAP",
    city: "Città",
    exportQuotePdf: "Esporta Preventivo PDF",
    quoteLeadRequired: "Compila Nome Progetto, CAP e Città per sbloccare il PDF.",
    quoteDetail: "Dettaglio Offerta",
    quoteDisclaimer: "I consumi indicati sono teorici e non includono gli sfridi di cantiere. Le quantità e i prezzi reali possono variare in base al supporto, alla posa e alle condizioni d'opera. Preventivo indicativo, non vincolante.",
    areaCalcTitle: "Calcola Superficie",
    areaCalcHint: "Aggiungi una stanza per ogni ambiente (es. Cucina, Salotto). Per stanze a L, aggiungi più sezioni. Puoi misurare ogni stanza con l'AR.",
    roomLabel: "Stanza",
    roomNamePlaceholder: "Nome stanza (es. Cucina)",
    roomsSummary: "Riepilogo stanze",
    addRoom: "Aggiungi stanza",
    measureRoomAR: "Misura con AR",
    arMeasured: "Misurato con AR",
    width: "Larghezza (m)",
    length: "Lunghezza (m)",
    addSection: "Aggiungi zona",
    totalArea: "Superficie totale",
    useArea: "Usa questa superficie",
    smartArea: "Calcola con Smartphone",
    arScan: "Scansiona con la fotocamera",
    arScanHint: "Posiziona i punti sul pavimento (dispositivi Android compatibili).",
    arInstr: "Punta gli angoli del pavimento e tocca «Aggiungi punto»",
    arScanning: "Muovi lentamente il telefono per rilevare il pavimento…",
    arLost: "Muovi lentamente il telefono verso il pavimento",
    arAddPoint: "Aggiungi punto",
    exitAr: "Esci",
    undoAr: "Annulla",
    arFinish: "Completa",
    arCancel: "Annulla",
    arError: "AR non disponibile su questo dispositivo.",
    arComingSoon: "Scansione AR in arrivo — usa il calcolatore qui sotto.",
    product: "Prodotto",
    base_legante: "Base legante",
    base_chimica: "Base chimica",
    tipologia: "Tipologia",
    diluizione: "Diluizione",
    consistenza: "Consistenza",
    comportamento_elastico: "Comportamento elastico",
    funzione: "Funzione",
    modulo_elastico: "Modulo elastico",
    shore_a: "Durezza Shore A",
    capacita_movimento: "Capacità di movimento",
    gel_time_min: "Tempo di gel",
    indurimento: "Indurimento completo",
    larghezza_rotolo: "Larghezza rotolo",
    spessore_telo: "Spessore telo/nastro",
    pompabile: "Pompabile a macchina",
    pendenze: "Formazione pendenze",
    idrorepellente: "Idrorepellente / Antimuffa",
    piscine: "Piscine / Alimentare",
    fondi_assorbenti: "Fondi assorbenti",
    fondi_non_assorbenti: "Fondi non assorbenti",
    barriera_vapore: "Barriera vapore",
    fibrorinforzato: "Fibrorinforzato",
    packTitle: "Confronto a confezione",
    packQty: "Quantità lavoro",
    packQtyDesc: "Superficie, metri lineari o pezzi da coprire.",
    packPrice: "Prezzo confezione",
    coveragePerPack: "Resa per confezione",
    packsNeeded: "Confezioni necessarie",
    costPerUnit: "Costo per unità",
    packUnitPz: "conf.",
    packDiffUnit: "I due prodotti hanno unità di misura diverse: il confronto diretto non è possibile.",
    finalCost: "Costo finale",
    unitM2: "Metri quadri",
    unitChfHour: "CHF all'ora",
    unitMinBag: "Minuti per sacco",
    unitMinPallet: "Minuti per bancale",
    unitMm: "Millimetri (denti)",
    unitMmFull: "Millimetri",
    loginTitle: "Accesso riservato",
    loginRequired: "Solo il proprietario può modificare o eliminare i prodotti. Accedi per continuare.",
    email: "Email",
    password: "Password",
    loginBtn: "Accedi",
    loginError: "Credenziali non valide",
    logout: "Esci",
    loggedInAs: "Accesso come",
    versusTitle: "Confronto caratteristiche",
    lowerBetter: "meno è meglio",
    higherBetter: "più è meglio",
    versusWins: "Vince su",
    winsUnit: "caratt.",
    equivSame: "I due prodotti sono tecnicamente equivalenti e confrontabili.",
    equivDiff: "Attenzione: i prodotti non sono del tutto equivalenti",
    reasonType: "tipologia diversa",
    reasonRes: "classe di prestazione diversa",
    reasonRapid: "presa rapida diversa",
    reasonComp: "componenti diversi (mono/bi)",
    suggestSimilar: "Prodotto più simile di",
    useThis: "Usa questo",
    radarTitle: "Radar caratteristiche",
    totalCost: "Costo totale",
    costPerM2: "Costo al m²",
    bagsNeeded: "Confezioni necessarie",
    totalKg: "Kg totali",
    resa: "Resa (m²/conf.)",
    // tech
    techData: "Dati tecnici",
    yieldTitle: "Come calcoliamo la resa",
    yieldSubtitle: "Dai dati della scheda tecnica, tradotti e resi in modo chiaro.",
    yieldFormulaLabel: "Calcolo del consumo",
    consumoTeoricoMm: "Consumo teorico (kg/m²/mm)",
    coefDenti: "Coeff. denti spatola",
    coefInclinazione: "Coeff. inclinazione",
    teethShort: "denti spatola",
    inclShort: "inclinazione",
    fromDatasheet: "da scheda tecnica",
    forArea: "Per",
    unitPackShort: "conf.",
    yieldManual: "resa fornita dalla scheda",
    noteConsumoTitle: "Nota della scheda (tradotta)",
    note_consumo: "Nota consumo/resa",
    resistenza: "Resistenza",
    certificazioni: "Certificazioni",
    colore: "Colore",
    application: "Impieghi",
    interno: "Interno",
    esterno: "Esterno",
    ambito: "Campo d'impiego",
    ambitoIntExt: "Interno + Esterno",
    ambitoInt: "Solo interno",
    applicazione: "Applicazione",
    posPavimento: "Pavimento",
    posParete: "Parete",
    posSoffitto: "Soffitto",
    serpentine: "Risc. a pavimento",
    acqua: "Acqua impasto (l)",
    rapida: "Presa rapida",
    ceramica: "Ceramica",
    mosaico: "Mosaico",
    pietra_naturale: "Pietra naturale",
    parquet: "Parquet",
    pareti: "Pareti",
    pavimenti: "Pavimenti",
    soffitto: "Soffitto",
    spessore: "Spessore (mm)",
    lavorabilita: "Lavorabilità (min)",
    pedonabile: "Pedonabile (h)",
    axResMpa: "Resistenza (MPa)",
    axThickMm: "Spessore max (mm)",
    rAxYield: "Resa",
    rAxConsumo: "Consumo",
    rAxWork: "Lavorabilità",
    rAxWalk: "Pedonabilità",
    rAxRes: "Resistenza",
    rAxThick: "Spessore",
    axElasticita: "Elasticità (Classe S)",
    axDensita: "Densità (kg/dm³)",
    rAxElast: "Elasticità",
    rAxDens: "Densità",
    noData: "Dato non dichiarato",
    densita: "Densità (kg/dm³)",
    maniProdotto: "Mani di prodotto",
    attesaPiastrelle: "Attesa piastrelle (giorni)",
    attesaParquet: "Attesa parquet (giorni)",
    allungamento: "Allungamento (%)",
    classeRipristino: "Classe ripristino",
    yes: "Sì",
    no: "No",
    // chat
    chatTitle: "Assistente tecnico",
    chatHint: "Chiedi qualsiasi cosa sulle schede tecniche salvate — anche dati non presenti in tabella.",
    chatPlaceholder: "Es. quale prodotto è migliore su fondo umido?",
    send: "Invia",
    thinking: "Sto consultando le schede…",
    chatIntro: "Ciao! Posso rispondere basandomi sui dati tecnici dei prodotti in archivio. Come posso aiutarti in cantiere?",
    // states
    emptyTitle: "Seleziona due prodotti per confrontarli",
    emptyBody: "Usa i selettori qui sopra. Se un prodotto manca, caricane la scheda tecnica.",
    incomplete: "Dati insufficienti per il calcolo",
    incompleteBody: "Questo prodotto non ha ancora resa e prezzo. Modifica i campi qui sotto o ricarica la scheda tecnica.",
    editable: "modificabile",
    reset: "Ripristina",
    priceBag: "Prezzo a confezione",
    editHint: "Campi modificabili",
    navCompare: "Confronta",
    navCatalog: "Catalogo",
    navMeasure: "Misura Area",
    navSpecs: "Analisi Capitolati",
    navSystems: "Sistemi Certificati",
    stratTitle: "Configuratore Sistema Pavimento",
    stratSubtitle: "Stratigrafia certificata {brand} · quantità e prezzi da scheda tecnica",
    stratQuotaTot: "Quota totale (incl. piastrella, mm)",
    stratTileThk: "Spessore piastrella (mm)",
    stratArea: "Superficie (m²)",
    stratBase: "Base",
    stratAutolivellante: "Autolivellante",
    stratMassetto: "Massetto",
    stratInvalid: "La quota disponibile è insufficiente per gli spessori impostati. Riduci colla/primer o aumenta la quota.",
    stratViewTitle: "Stratigrafia · vista esplosa",
    stratQuota: "Quota",
    stratHint: "Passa sopra o clicca una lastra per aprire la scheda tecnica",
    stratLayerTile: "Piastrella",
    stratLayerColla: "Colla",
    stratLayerPrimer: "Primer di fondo",
    stratLayerSubstrate: "Sottofondo grezzo",
    stratLayerSerpentine: "Serpentine",
    stratPrimerToggle: "Primer di fondo sul sottofondo grezzo",
    stratNotAlways: "(non sempre necessario)",
    stratOptional: "(opzionale)",
    stratPrecolla: "Primer pre-colla",
    stratColla: "Colla per piastrella",
    stratThkCalc: "(spessore calcolato)",
    stratFieldProduct: "Prodotto",
    stratFieldThk: "Spessore",
    stratFieldPriceKg: "Prezzo al kg",
    stratNoProduct: "— nessun prodotto —",
    stratOther: "ALTRO MATERIALE (valore 0)",
    stratSysTitle: "Scegli il sistema",
    stratSysTilesPci: "Piastrelle PCI",
    stratSysTilesSika: "Piastrelle Sika",
    stratBag: "sacco",
    stratKgNeeded: "kg necessari",
    stratLeftover: "avanzano",
    stratLeftoverShort: "avanzo",
    stratNoConstraint: "Nessun vincolo di spessore",
    stratOutRange: "Fuori range",
    stratAtLimit: "Al limite",
    stratNearLimit: "Vicino al limite",
    stratCompatible: "Compatibile",
    stratHeatingToggle: "Serpentine riscaldamento a pavimento",
    stratPipeDia: "Ø tubo (mm)",
    stratPipeSpacing: "Interasse (mm)",
    stratLeveler: "livellante",
    stratPipeSaving: "Serpentine Ø{dia}mm · interasse {spacing}mm → ~{eq} mm di livellante in meno per m² (materiale ridotto automaticamente)",
    stratPrecollaToggle: "Aggiungi Primer pre-colla",
    stratAddPrecolla: "Aggiungi Primer pre-colla",
    stratRmPrecolla: "Rimuovi Primer pre-colla",
    stratAddHeating: "Aggiungi Serpentine riscaldamento",
    stratRmHeating: "Rimuovi Serpentine riscaldamento",
    stratAddPrimer: "Aggiungi Primer di fondo",
    stratRmPrimer: "Rimuovi Primer di fondo",
    stratPhotoTitle: "Foto sottofondo (opz.)",
    stratUploadPhoto: "Carica foto",
    stratAnalyze: "Analizza e suggerisci primer",
    stratAnalyzing: "Analisi in corso…",
    stratChange: "Cambia",
    stratRemove: "Rimuovi",
    stratAnalysisDone: "Analisi completata",
    stratAnalysisFail: "Analisi non riuscita",
    stratSubstrateLbl: "Sottofondo:",
    stratPrimerRecommended: "Primer consigliato:",
    stratTotal: "Totale sistema",
    stratGenPDF: "Genera PDF",
    stratGroutTitle: "Malte Fuganti",
    stratGroutTileL: "Lunghezza piastrella (cm)",
    stratGroutTileW: "Larghezza piastrella (cm)",
    stratGroutJoint: "Larghezza giunto (mm)",
    stratGroutResult: "Fabbisogno malta fugante",
    stratGroutReuse: "Spessore e superficie presi dal configuratore",
    stratDatasheetDefault: "Scheda tecnica prodotto",
    stratDsCategory: "Categoria",
    stratDsResistance: "Resistenza",
    stratDsConsumption: "Consumo",
    stratDsYield: "Resa",
    stratDsPackage: "Confezione",
    stratDsThickness: "Spessore",
    stratDsWorkability: "Lavorabilità",
    stratDsWalkable: "Pedonabile",
    stratDsPriceKg: "Prezzo/kg",
    stratDsColor: "Colore",
    stratDsCerts: "Certificazioni",
    stratDsFeatures: "Caratteristiche",
    stratFlagRapid: "Rapida",
    stratFlagInterior: "Interno",
    stratFlagExterior: "Esterno",
    stratPdfHeader: "Configuratore Sistema Pavimento · {brand}",
    stratPdfQuota: "Quota totale",
    stratPdfTile: "Piastrella",
    stratPdfArea: "Superficie",
    stratColLayer: "Strato",
    stratColProduct: "Prodotto",
    stratColThk: "Spessore",
    stratColCompat: "Compatibilità",
    stratColQty: "Quantità",
    stratColSubtotal: "Subtotale",
    stratCompatOK: "OK",
    stratCompatLimit: "LIMITE",
    stratCompatOut: "FUORI RANGE",
    stratPdfTotal: "TOTALE SISTEMA",
    stratPdfDisclaimer: "Prezzi indicativi IVA esclusa. Quantità calcolate dalle rese di scheda tecnica PCI.",
    sysTitle: "Configuratore Sistemi Intelligenti (Visione 2026)",
    sysBadge: "Prossima Implementazione",
    sysSub: "Un unico configuratore per l'intero sistema di posa, dallo strato di fondo alla finitura.",
    sysStep1: "Input Cantiere",
    sysStep1d: "Carica le foto del sottofondo, inserisci i m² e la quota totale disponibile (mm).",
    sysStep2: "Obiettivo Finale",
    sysStep2d: "Seleziona il brand (Sika, PCI...) e il tipo di rivestimento: piastrelle, parquet o resine industriali.",
    sysStep3: "Calcolo Stratigrafico",
    sysStep3d: "L'AI elabora il sistema completo dividendo la quota disponibile tra i vari strati necessari.",
    sysStrati: "Esempio di stratigrafia",
    sysLayer4: "Rivestimento finale",
    sysLayer4d: "es. Piastrella / Parquet",
    sysLayer3: "Adesivo / Colla",
    sysLayer3d: "calcolato automaticamente",
    sysLayer2: "Livellina / Autolivellante",
    sysLayer2d: "calcolato per compensare la quota",
    sysLayer1: "Primer",
    sysLayer1d: "specifico per il sottofondo fotografato",
    sysValueTitle: "Vantaggi",
    sysValue1: "Vendita del sistema completo",
    sysValue2: "Garanzia tecnica certificata",
    sysValue3: "Zero errori di posa",
    sysDesc: "Seleziona il tuo obiettivo di cantiere. METEROX configurerà automaticamente il sistema completo certificato Sika/PCI/Schönox per ogni applicazione:",
    sysSelector: "Scegli Tecnologia (Piastrelle, Parquet, Resine...)",
    sysT1: "Piastrelle & Pietre",
    sysT1d: "Sottofondi, membrane, adesivi e stucchi.",
    sysT2: "Parquet & Resilienti",
    sysT2d: "Barriere vapore, livellanti e colle specifiche.",
    sysT3: "Resine Industriali",
    sysT3d: "Primer, strati di fondo e finiture protettive.",
    sysT4: "Ripristino & Strade",
    sysT4d: "Sistemi di protezione ferri e malte strutturali.",
    sysTooltip: "Questa funzionalità sarà disponibile nel prossimo aggiornamento",
    specsTitle: "Analisi Intelligente Capitolati (Beta)",
    specsDesc: "Carica i tuoi file PDF o Excel. L'intelligenza artificiale di METEROX analizzerà le voci di capitolato e suggerirà automaticamente i prodotti Sika equivalenti con i relativi costi aggiornati.",
    specsComingSoon: "PRESTO IN ARRIVO",
    specsUpload: "Carica Capitolato",
    specsTooltip: "Questa funzionalità sarà disponibile nel prossimo aggiornamento",
    specsStep1: "Carica il capitolato",
    specsStep1d: "PDF o Excel con le voci di gara",
    specsStep2: "Analisi AI",
    specsStep2d: "Riconoscimento automatico delle voci",
    specsStep3: "Prodotti equivalenti",
    specsStep3d: "Match Sika + costi aggiornati",
    measureTitle: "Misura l'area delle stanze",
    measureBody: "Misura al volo la metratura con la fotocamera (AR) o inserendo le dimensioni. Aggiungi più stanze, poi conferma: ti porteremo direttamente a Scegli Prodotto con i m² già pronti.",
    measureStart: "Avvia misurazione",
    measureFab: "Misura Area",
    measureReady: "Metratura pronta",
    measurePickHint: "Scegli il materiale qui sotto: la metratura è già impostata.",
    manageTitle: "Gestione prodotti",
    manageHint: "Modifica o elimina i prodotti dell'archivio.",
    search: "Cerca prodotto o marca…",
    allBrands: "Tutte le marche",
    edit: "Modifica",
    del: "Elimina",
    deleteConfirm: "Eliminare questo prodotto?",
    deleteConfirmBody: "L'azione è definitiva e non può essere annullata.",
    save: "Salva",
    completeBadge: "Completo",
    incompleteBadge: "Incompleto",
    completeOk: "Prodotto completo — spunta verde attiva",
    completeReqTitle: "Per la spunta verde servono ancora:",
    exportPdf: "Esporta PDF",
    noResults: "Nessun prodotto trovato",
    lockInfo: "Stessa area del Prodotto A — scegli sottocategoria, marca e prodotto.",
    productsCount: "prodotti",
  },
  de: {
    tagline: "Das digitale Ökosystem für Profis",
    bestMatch: "Beste Übereinstimmung",
    techEquivalent: "Technisch gleichwertig",
    matchInfo: "Diese Produkte wurden nach ähnlichen technischen Merkmalen (Unterkategorie und Klasse) zusammengeführt.",
    cookieTitle: "Wir respektieren Ihre Privatsphäre",
    cookieText: "Wir verwenden technisch notwendige Cookies und, mit Ihrer Zustimmung, Cookies für Statistiken und zur Verbesserung der Nutzung.",
    cookieAccept: "Alle akzeptieren",
    cookieReject: "Nur notwendige",
    contactTitle: "Fragen oder Zusammenarbeit?",
    contactSubtitle: "Schreiben Sie uns – wir melden uns schnellstmöglich.",
    contactName: "Name",
    contactEmail: "Ihre E-Mail",
    contactCompany: "Firma (optional)",
    contactMessage: "Nachricht",
    contactSend: "Nachricht senden",
    contactSending: "Senden...",
    contactSuccess: "Nachricht gesendet! Wir melden uns bald.",
    contactError: "Senden fehlgeschlagen. Bitte erneut versuchen.",
    contactCta: "Kontakt aufnehmen",
    subtitle: "Wähle zwei Produkte und finde heraus, welches sich wirklich lohnt – mit Ergiebigkeit und Kosten.",
    compare: "Vergleichen",
    catalog: "Katalog",
    datasheetMissing: "Technisches Datenblatt fehlt",
    category: "Bereich",
    subcategory: "Unterkategorie",
    brand: "Marke",
    product: "Produkt",
    selectPlaceholder: "Auswählen…",
    filtersTitle: "Schnellfilter",
    filtersHint: "Tippe auf die Filter, um die Liste einzugrenzen. Die manuelle Auswahl bleibt möglich.",
    fInterno: "Innen",
    fEsterno: "Außen",
    fClasse: "Klasse S1/S2",
    fRapido: "Schnell",
    fRapidaAsc: "Schnelltrocknend",
    fPompabile: "Pumpbar",
    fUV: "UV-beständig",
    fBicomp: "Zweikomponentig",
    fFlex: "Flexibel",
    fThickness: "Dicke (mm)",
    fResults: "Produkte",
    noMatch: "Kein Produkt entspricht den gewählten Kriterien",
    clearFilters: "Filter zurücksetzen",
    productA: "Produkt A",
    productB: "Produkt B",
    addMissing: "Produkt fehlt? Technisches Datenblatt hochladen",
    addMissingHint: "Die KI liest das PDF und extrahiert die Daten automatisch.",
    uploadTitle: "Datenblatt hochladen",
    fabAddDatasheet: "Datenblatt hinzufügen",
    multiUseLabel: "Mehrere Anwendungen erkannt",
    removeUse: "Diese Anwendung entfernen",
    uploadHint: "Die KI liest das PDF oder Bild (in jeder Sprache) und extrahiert die Daten automatisch. Fehlt ein Wert im Datenblatt, leitet Gemini ihn aus seinem Produktwissen ab (bitte prüfen).",
    uploadDrop: "Datei hierher ziehen oder klicken zum Auswählen",
    uploadFormats: "PDF, PNG, JPG",
    extracting: "Datenblatt wird mit Gemini gelesen…",
    reviewExtracted: "Extrahierte Daten prüfen und korrigieren",
    saveProduct: "Produkt speichern",
    cancel: "Abbrechen",
    fileRequired: "Bitte zuerst eine Datei wählen",
    extractError: "Extraktion fehlgeschlagen. Bitte mit lesbarerer Datei erneut versuchen.",
    savedOk: "Produkt im Katalog gespeichert",
    aiEstimatedHint: "Einige hervorgehobene Werte sind SCHÄTZUNGEN (nicht im Datenblatt, aus Online-Marktpreisen abgeleitet): bitte prüfen.",
    dupSimilar: "ÄHNLICHES Produkt bereits vorhanden:",
    dupWarn: "Ein ähnliches Produkt existiert bereits:",
    autoCategory: "Automatisch zugewiesene Kategorie",
    editCategoryHint: "bei Bedarf änderbar",
    chooseForQuote: "Für Angebot wählen",
    comparison: "Vergleich",
    winner: "Bestes",
    difference: "Differenz",
    savings: "Ersparnis",
    saveOf: "Ersparnis",
    parameters: "Berechnungsparameter",
    metratura: "Zu verlegende Fläche",
    laborSection: "Verlegekosten (optional · Standard 0)",
    spessore2mani: "Dicke 2 Anstriche",
    pricePerKg: "Preis pro kg",
    useForQuote: "Für Angebot verwenden",
    costBreakdown: "Kostenaufstellung",
    quoteRecapTitle: "Ausgewähltes Produkt",
    consumptionTitle: "Verbrauchsdetails",
    quoteEmptyTitle: "Kein Produkt ausgewählt",
    quoteEmptyBody: "Wähle oben ein Produkt, um die Menge nach m² zu berechnen.",
    goToComparator: "Zum Vergleich",
    marketPriceHint: "Passe den Preis an den aktuellen Markt an.",
    consumption: "Verbrauch",
    bagWeight: "Gebindegewicht",
    advanced: "Baustellen-Parameter",
    salary: "Stundenlohn",
    transportMin: "Sacktransport",
    mixingMin: "Anmischen",
    palletMin: "Lagertransport",
    bagsPerPallet: "Säcke pro Palette",
    productCost: "Produktkosten",
    transportCost: "Sacktransport",
    mixingCost: "Anmischen",
    palletCost: "Lagertransport",
    costComposition: "Kostenzusammensetzung",
    descMetratura: "Gesamte zu belegende Fläche.",
    descSalary: "Durchschnittlicher Stundenlohn, den ein Unternehmen einem eigenen Mitarbeiter zahlt.",
    descTransport: "Zeit, um jeden Sack zur Verlegestelle zu bringen.",
    descMixing: "Zeit zum Anmischen jedes Sacks.",
    descPallet: "Zeit für das Bewegen der Paletten aus dem Lager.",
    readonlyHint: "Feste Produktdaten (nicht bearbeitbar)",
    trowel: "Kelle",
    trowelDesc: "Zahnung der Kelle: ändert den Verbrauch (Basis 6 mm).",
    tileA: "Fliesenseite A",
    tileB: "Fliesenseite B",
    tileThickness: "Fliesendicke",
    jointWidth: "Fugenbreite",
    groutDesc: "Fliesen- und Fugengeometrie: berechnet die benötigten kg Fugenmörtel.",
    groutJoint: "Fuge",
    interpolated: "interpoliert",
    unitCm: "Zentimeter",
    navQuote: "Produkt wählen",
    quoteTitle: "Produkt wählen",
    quoteSubtitle: "Du weisst schon, welches Produkt? Wähle es und berechne die Menge nach m². Gleiche Infos wie im Vergleich, ohne Diagramme.",
    shareTitle: "Ergebnisse teilen / Bestellung senden",
    shareHint: "Daten ausfüllen: PDF herunterladen und, wenn die Empfänger-E-Mail eingegeben wird, erhält dieser eine Kopie.",
    fCompany: "Firma / Handwerker *",
    fProject: "Projekt / Baustelle *",
    fCityZip: "Ort oder PLZ der Baustelle *",
    fRecipient: "Empfänger-E-Mail (Kunde/Händler) — optional",
    fNotes: "Zusätzliche Notizen (optional)",
    btnSend: "Senden und PDF herunterladen",
    shareRequired: "Firma, Projekt und Ort/PLZ ausfüllen.",
    disclaimerShort: "Von Nutzern für Nutzer eingegebene Daten. Keine Haftung für Rechenfehler.",
    copyright: "© 2026 METEROX. Ausschließliches geistiges Eigentum. Alle Rechte vorbehalten.",
    dsView: "Ansehen/Download",
    dsReplace: "Ersetzen",
    dsAttach: "Datenblatt anhängen",
    navLeads: "Leads",
    leadsTitle: "Gesammelte Leads & Angebote",
    leadsEmpty: "Noch keine Leads.",
    thDate: "Datum",
    thCompany: "Firma",
    thProject: "Projekt",
    thCity: "Ort/PLZ",
    thQty: "Menge",
    thEmail: "Empfänger",
    viewLeads: "Leads",
    viewProducts: "Produkte",
    viewContacts: "Nachrichten",
    contactsTitle: "Erhaltene Nachrichten",
    contactsEmpty: "Keine Nachrichten erhalten.",
    toastSent: "Gesendet und PDF heruntergeladen",
    toastDownloaded: "PDF heruntergeladen",
    markup: "Handwerker-Aufschlag (%)",
    clientPrice: "Kundenpreis",
    quoteExportTitle: "PDF-Angebot exportieren",
    quoteExportHint: "Projektdaten eingeben, um das PDF zu erstellen.",
    projectName: "Projektname",
    zip: "PLZ",
    city: "Stadt",
    exportQuotePdf: "PDF-Angebot exportieren",
    quoteLeadRequired: "Projektname, PLZ und Stadt ausfüllen, um das PDF freizuschalten.",
    quoteDetail: "Angebotsdetail",
    quoteDisclaimer: "Die angegebenen Verbräuche sind theoretisch und enthalten keinen Verschnitt. Reale Mengen und Preise können je nach Untergrund und Verarbeitung abweichen. Unverbindliches Richtangebot.",
    areaCalcTitle: "Fläche berechnen",
    areaCalcHint: "Füge für jeden Raum einen Eintrag hinzu (z.B. Küche, Wohnzimmer). Für L-förmige Räume mehrere Bereiche. Jeder Raum per AR messbar.",
    roomLabel: "Raum",
    roomNamePlaceholder: "Raumname (z.B. Küche)",
    roomsSummary: "Raumübersicht",
    addRoom: "Raum hinzufügen",
    measureRoomAR: "Mit AR messen",
    arMeasured: "Mit AR gemessen",
    width: "Breite (m)",
    length: "Länge (m)",
    addSection: "Bereich hinzufügen",
    totalArea: "Gesamtfläche",
    useArea: "Diese Fläche verwenden",
    smartArea: "Mit Smartphone messen",
    arScan: "Mit Kamera scannen",
    arScanHint: "Punkte auf dem Boden setzen (kompatible Android-Geräte).",
    arInstr: "Ziele auf die Bodenecken und tippe auf «Punkt hinzufügen»",
    arScanning: "Bewege das Telefon langsam, um den Boden zu erkennen…",
    arLost: "Bewege das Telefon langsam zum Boden",
    arAddPoint: "Punkt hinzufügen",
    exitAr: "Zurück",
    undoAr: "Rückgängig",
    arFinish: "Fertig",
    arCancel: "Abbrechen",
    arError: "AR auf diesem Gerät nicht verfügbar.",
    arComingSoon: "AR-Scan folgt bald – bitte den Rechner unten nutzen.",
    product: "Produkt",
    base_legante: "Bindemittel",
    base_chimica: "Chemische Basis",
    tipologia: "Typ",
    diluizione: "Verdünnung",
    consistenza: "Konsistenz",
    comportamento_elastico: "Elastisches Verhalten",
    funzione: "Funktion",
    modulo_elastico: "E-Modul",
    shore_a: "Shore-A-Härte",
    capacita_movimento: "Bewegungsaufnahme",
    gel_time_min: "Gelzeit",
    indurimento: "Aushärtung",
    larghezza_rotolo: "Rollenbreite",
    spessore_telo: "Dicke Bahn/Band",
    pompabile: "Maschinengängig",
    pendenze: "Gefällebildung",
    idrorepellente: "Wasserabweisend / Antischimmel",
    piscine: "Schwimmbad / Lebensmittel",
    fondi_assorbenti: "Saugende Untergründe",
    fondi_non_assorbenti: "Nicht saugende Untergründe",
    barriera_vapore: "Dampfsperre",
    fibrorinforzato: "Faserverstärkt",
    packTitle: "Vergleich pro Gebinde",
    packQty: "Arbeitsmenge",
    packQtyDesc: "Fläche, Laufmeter oder Stück abzudecken.",
    packPrice: "Gebindepreis",
    coveragePerPack: "Ergiebigkeit pro Gebinde",
    packsNeeded: "Benötigte Gebinde",
    costPerUnit: "Kosten pro Einheit",
    packUnitPz: "Stk.",
    packDiffUnit: "Die beiden Produkte haben unterschiedliche Einheiten: ein direkter Vergleich ist nicht möglich.",
    finalCost: "Endkosten",
    unitM2: "Quadratmeter",
    unitChfHour: "CHF pro Stunde",
    unitMinBag: "Minuten pro Sack",
    unitMinPallet: "Minuten pro Palette",
    unitMm: "Millimeter (Zahnung)",
    unitMmFull: "Millimeter",
    loginTitle: "Geschützter Zugang",
    loginRequired: "Nur der Eigentümer kann Produkte bearbeiten oder löschen. Bitte anmelden.",
    email: "E-Mail",
    password: "Passwort",
    loginBtn: "Anmelden",
    loginError: "Ungültige Anmeldedaten",
    logout: "Abmelden",
    loggedInAs: "Angemeldet als",
    versusTitle: "Merkmalsvergleich",
    lowerBetter: "weniger ist besser",
    higherBetter: "mehr ist besser",
    versusWins: "Führt bei",
    winsUnit: "Merkm.",
    equivSame: "Die beiden Produkte sind technisch gleichwertig und vergleichbar.",
    equivDiff: "Achtung: die Produkte sind nicht ganz gleichwertig",
    reasonType: "andere Typologie",
    reasonRes: "andere Leistungsklasse",
    reasonRapid: "anderes Schnellabbinden",
    reasonComp: "andere Komponenten (1K/2K)",
    suggestSimilar: "Ähnlichstes Produkt von",
    useThis: "Dieses verwenden",
    radarTitle: "Merkmals-Radar",
    totalCost: "Gesamtkosten",
    costPerM2: "Kosten pro m²",
    bagsNeeded: "Benötigte Gebinde",
    totalKg: "Kg gesamt",
    resa: "Ergiebigkeit (m²/Geb.)",
    techData: "Technische Daten",
    yieldTitle: "So berechnen wir die Ergiebigkeit",
    yieldSubtitle: "Aus den Datenblattwerten, übersetzt und klar dargestellt.",
    yieldFormulaLabel: "Verbrauchsberechnung",
    consumoTeoricoMm: "Theor. Verbrauch (kg/m²/mm)",
    coefDenti: "Zahnungs-Koeff.",
    coefInclinazione: "Neigungs-Koeff.",
    teethShort: "Zähne",
    inclShort: "Neigung",
    fromDatasheet: "aus Datenblatt",
    forArea: "Für",
    unitPackShort: "Geb.",
    yieldManual: "Ergiebigkeit laut Datenblatt",
    noteConsumoTitle: "Datenblatt-Hinweis (übersetzt)",
    note_consumo: "Verbrauchshinweis",
    resistenza: "Verformbarkeit",
    certificazioni: "Zertifizierungen",
    colore: "Farbe",
    application: "Anwendungen",
    interno: "Innen",
    esterno: "Aussen",
    ambito: "Anwendungsbereich",
    ambitoIntExt: "Innen + Aussen",
    ambitoInt: "Nur innen",
    applicazione: "Anwendung",
    posPavimento: "Boden",
    posParete: "Wand",
    posSoffitto: "Decke",
    serpentine: "Fussbodenheizung",
    acqua: "Anmachwasser (l)",
    rapida: "Schnellabbindend",
    ceramica: "Keramik",
    mosaico: "Mosaik",
    pietra_naturale: "Naturstein",
    parquet: "Parkett",
    pareti: "Wände",
    pavimenti: "Böden",
    soffitto: "Decke",
    spessore: "Schichtdicke (mm)",
    lavorabilita: "Verarbeitungszeit (Min)",
    pedonabile: "Begehbar (h)",
    axResMpa: "Widerstand (MPa)",
    axThickMm: "Max. Dicke (mm)",
    rAxYield: "Ergiebigk.",
    rAxConsumo: "Verbrauch",
    rAxWork: "Verarb.",
    rAxWalk: "Begehbar",
    rAxRes: "Widerstand",
    rAxThick: "Dicke",
    axElasticita: "Elastizität (Klasse S)",
    axDensita: "Dichte (kg/dm³)",
    rAxElast: "Elastizität",
    rAxDens: "Dichte",
    noData: "Nicht angegeben",
    densita: "Dichte (kg/dm³)",
    maniProdotto: "Anzahl Anstriche",
    attesaPiastrelle: "Wartezeit Fliesen (Tage)",
    attesaParquet: "Wartezeit Parkett (Tage)",
    allungamento: "Dehnung (%)",
    classeRipristino: "Sanierungsklasse",
    yes: "Ja",
    no: "Nein",
    chatTitle: "Technischer Assistent",
    chatHint: "Frag alles zu den gespeicherten Datenblättern – auch Daten ausserhalb der Tabelle.",
    chatPlaceholder: "Z.B. welches Produkt eignet sich für feuchten Untergrund?",
    send: "Senden",
    thinking: "Ich prüfe die Datenblätter…",
    chatIntro: "Hallo! Ich antworte auf Basis der technischen Produktdaten im Archiv. Wie kann ich auf der Baustelle helfen?",
    emptyTitle: "Wähle zwei Produkte zum Vergleichen",
    emptyBody: "Nutze die Auswahl oben. Fehlt ein Produkt, lade dessen Datenblatt hoch.",
    incomplete: "Unzureichende Daten für die Berechnung",
    incompleteBody: "Diesem Produkt fehlen Ergiebigkeit und Preis. Bearbeite die Felder unten oder lade das Datenblatt neu.",
    editable: "bearbeitbar",
    reset: "Zurücksetzen",
    priceBag: "Preis pro Gebinde",
    editHint: "Bearbeitbare Felder",
    navCompare: "Vergleichen",
    navCatalog: "Katalog",
    navMeasure: "Fläche messen",
    navSpecs: "Leistungsanalyse",
    navSystems: "Zertifizierte Systeme",
    stratTitle: "Bodenaufbau-Konfigurator",
    stratSubtitle: "Zertifizierter {brand}-Aufbau · Mengen und Preise aus dem Datenblatt",
    stratQuotaTot: "Gesamthöhe (inkl. Fliese, mm)",
    stratTileThk: "Fliesenstärke (mm)",
    stratArea: "Fläche (m²)",
    stratBase: "Unterlage",
    stratAutolivellante: "Ausgleichsmasse",
    stratMassetto: "Estrich",
    stratInvalid: "Die verfügbare Höhe reicht für die eingestellten Stärken nicht aus. Reduziere Kleber/Grundierung oder erhöhe die Höhe.",
    stratViewTitle: "Schichtaufbau · Explosionsansicht",
    stratQuota: "Höhe",
    stratHint: "Fahre über eine Platte oder klicke sie an, um das Datenblatt zu öffnen",
    stratLayerTile: "Fliese",
    stratLayerColla: "Kleber",
    stratLayerPrimer: "Grundierung",
    stratLayerSubstrate: "Roher Untergrund",
    stratLayerSerpentine: "Heizschlangen",
    stratPrimerToggle: "Grundierung auf rohem Untergrund",
    stratNotAlways: "(nicht immer nötig)",
    stratOptional: "(optional)",
    stratPrecolla: "Vor-Grundierung",
    stratColla: "Fliesenkleber",
    stratThkCalc: "(berechnete Stärke)",
    stratFieldProduct: "Produkt",
    stratFieldThk: "Stärke",
    stratFieldPriceKg: "Preis pro kg",
    stratNoProduct: "— kein Produkt —",
    stratOther: "ANDERES MATERIAL (Wert 0)",
    stratSysTitle: "System wählen",
    stratSysTilesPci: "PCI Fliesen",
    stratSysTilesSika: "Sika Fliesen",
    stratBag: "Sack",
    stratKgNeeded: "kg benötigt",
    stratLeftover: "Überschuss",
    stratLeftoverShort: "Rest",
    stratNoConstraint: "Keine Stärkenbeschränkung",
    stratOutRange: "Außerhalb des Bereichs",
    stratAtLimit: "An der Grenze",
    stratNearLimit: "Nahe der Grenze",
    stratCompatible: "Kompatibel",
    stratHeatingToggle: "Fußbodenheizung-Schlangen",
    stratPipeDia: "Ø Rohr (mm)",
    stratPipeSpacing: "Abstand (mm)",
    stratLeveler: "Ausgleichsmasse",
    stratPipeSaving: "Heizschlangen Ø{dia}mm · Abstand {spacing}mm → ~{eq} mm weniger Ausgleichsmasse pro m² (Material automatisch reduziert)",
    stratPrecollaToggle: "Vor-Grundierung hinzufügen",
    stratAddPrecolla: "Vor-Grundierung hinzufügen",
    stratRmPrecolla: "Vor-Grundierung entfernen",
    stratAddHeating: "Fußbodenheizung hinzufügen",
    stratRmHeating: "Fußbodenheizung entfernen",
    stratAddPrimer: "Grundierung hinzufügen",
    stratRmPrimer: "Grundierung entfernen",
    stratPhotoTitle: "Foto Untergrund (opt.)",
    stratUploadPhoto: "Foto hochladen",
    stratAnalyze: "Analysieren und Grundierung vorschlagen",
    stratAnalyzing: "Analyse läuft…",
    stratChange: "Ändern",
    stratRemove: "Entfernen",
    stratAnalysisDone: "Analyse abgeschlossen",
    stratAnalysisFail: "Analyse fehlgeschlagen",
    stratSubstrateLbl: "Untergrund:",
    stratPrimerRecommended: "Empfohlene Grundierung:",
    stratTotal: "Systemsumme",
    stratGenPDF: "PDF erstellen",
    stratGroutTitle: "Fugenmörtel",
    stratGroutTileL: "Fliesenlänge (cm)",
    stratGroutTileW: "Fliesenbreite (cm)",
    stratGroutJoint: "Fugenbreite (mm)",
    stratGroutResult: "Fugenmörtelbedarf",
    stratGroutReuse: "Stärke und Fläche aus dem Konfigurator übernommen",
    stratDatasheetDefault: "Produktdatenblatt",
    stratDsCategory: "Kategorie",
    stratDsResistance: "Festigkeit",
    stratDsConsumption: "Verbrauch",
    stratDsYield: "Ergiebigkeit",
    stratDsPackage: "Gebinde",
    stratDsThickness: "Stärke",
    stratDsWorkability: "Verarbeitungszeit",
    stratDsWalkable: "Begehbar",
    stratDsPriceKg: "Preis/kg",
    stratDsColor: "Farbe",
    stratDsCerts: "Zertifizierungen",
    stratDsFeatures: "Eigenschaften",
    stratFlagRapid: "Schnell",
    stratFlagInterior: "Innen",
    stratFlagExterior: "Außen",
    stratPdfHeader: "Bodenaufbau-Konfigurator · {brand}",
    stratPdfQuota: "Gesamthöhe",
    stratPdfTile: "Fliese",
    stratPdfArea: "Fläche",
    stratColLayer: "Schicht",
    stratColProduct: "Produkt",
    stratColThk: "Stärke",
    stratColCompat: "Kompatibilität",
    stratColQty: "Menge",
    stratColSubtotal: "Zwischensumme",
    stratCompatOK: "OK",
    stratCompatLimit: "GRENZE",
    stratCompatOut: "AUSSERHALB",
    stratPdfTotal: "SYSTEMSUMME",
    stratPdfDisclaimer: "Richtpreise exkl. MwSt. Mengen berechnet aus den Ergiebigkeiten des PCI-Datenblatts.",
    sysTitle: "Intelligenter System-Konfigurator (Vision 2026)",
    sysBadge: "Nächste Umsetzung",
    sysSub: "Ein einziger Konfigurator für den gesamten Verlegeaufbau, von der Grundschicht bis zum Belag.",
    sysStep1: "Baustellen-Input",
    sysStep1d: "Laden Sie Fotos des Untergrunds hoch, geben Sie m² und die verfügbare Gesamthöhe (mm) ein.",
    sysStep2: "Endziel",
    sysStep2d: "Wählen Sie die Marke (Sika, PCI...) und den Belagstyp: Fliesen, Parkett oder Industrieharze.",
    sysStep3: "Schichtberechnung",
    sysStep3d: "Die KI erstellt das komplette System und verteilt die verfügbare Höhe auf die nötigen Schichten.",
    sysStrati: "Beispiel-Schichtaufbau",
    sysLayer4: "Endbelag",
    sysLayer4d: "z. B. Fliese / Parkett",
    sysLayer3: "Kleber",
    sysLayer3d: "automatisch berechnet",
    sysLayer2: "Ausgleichs-/Nivelliermasse",
    sysLayer2d: "berechnet zum Höhenausgleich",
    sysLayer1: "Primer",
    sysLayer1d: "spezifisch für den fotografierten Untergrund",
    sysValueTitle: "Vorteile",
    sysValue1: "Verkauf des Komplettsystems",
    sysValue2: "Zertifizierte technische Garantie",
    sysValue3: "Null Verlegefehler",
    sysDesc: "Wählen Sie Ihr Baustellenziel. METEROX konfiguriert automatisch das komplette zertifizierte Sika/PCI/Schönox-System für jede Anwendung:",
    sysSelector: "Technologie wählen (Fliesen, Parkett, Harze...)",
    sysT1: "Fliesen & Naturstein",
    sysT1d: "Untergründe, Membranen, Kleber und Fugenmörtel.",
    sysT2: "Parkett & elastische Beläge",
    sysT2d: "Dampfsperren, Ausgleichsmassen und spezifische Kleber.",
    sysT3: "Industrieharze",
    sysT3d: "Primer, Grundschichten und Schutzbeschichtungen.",
    sysT4: "Instandsetzung & Straßen",
    sysT4d: "Korrosionsschutzsysteme und Strukturmörtel.",
    sysTooltip: "Diese Funktion wird im nächsten Update verfügbar sein",
    specsTitle: "Intelligente Leistungsverzeichnis-Analyse (Beta)",
    specsDesc: "Laden Sie Ihre PDF- oder Excel-Dateien hoch. Die KI von METEROX analysiert die Positionen des Leistungsverzeichnisses und schlägt automatisch gleichwertige Sika-Produkte mit aktuellen Kosten vor.",
    specsComingSoon: "DEMNÄCHST",
    specsUpload: "Leistungsverzeichnis hochladen",
    specsTooltip: "Diese Funktion wird im nächsten Update verfügbar sein",
    specsStep1: "Verzeichnis hochladen",
    specsStep1d: "PDF oder Excel mit den Positionen",
    specsStep2: "KI-Analyse",
    specsStep2d: "Automatische Positionserkennung",
    specsStep3: "Gleichwertige Produkte",
    specsStep3d: "Sika-Match + aktuelle Kosten",
    measureTitle: "Raumfläche messen",
    measureBody: "Messen Sie die Fläche schnell mit der Kamera (AR) oder per Eingabe der Masse. Fügen Sie mehrere Räume hinzu und bestätigen Sie: Sie gelangen direkt zu «Produkt wählen» mit bereits eingetragenen m².",
    measureStart: "Messung starten",
    measureFab: "Fläche messen",
    measureReady: "Fläche bereit",
    measurePickHint: "Wählen Sie unten das Produkt – die Fläche ist bereits gesetzt.",
    manageTitle: "Produktverwaltung",
    manageHint: "Produkte im Archiv bearbeiten oder löschen.",
    search: "Produkt oder Marke suchen…",
    allBrands: "Alle Marken",
    edit: "Bearbeiten",
    del: "Löschen",
    deleteConfirm: "Dieses Produkt löschen?",
    deleteConfirmBody: "Die Aktion ist endgültig und kann nicht rückgängig gemacht werden.",
    save: "Speichern",
    completeBadge: "Vollständig",
    incompleteBadge: "Unvollständig",
    completeOk: "Produkt vollständig — grünes Häkchen aktiv",
    completeReqTitle: "Für das grüne Häkchen fehlt noch:",
    exportPdf: "PDF export",
    noResults: "Kein Produkt gefunden",
    lockInfo: "Gleicher Bereich wie Produkt A — Unterkategorie, Marke und Produkt wählen.",
    productsCount: "Produkte",
  },
  fr: {
    tagline: "L'écosystème numérique pour les professionnels",
    bestMatch: "Meilleure correspondance",
    techEquivalent: "Équivalent technique",
    matchInfo: "Ces produits ont été associés selon des caractéristiques techniques similaires (sous-catégorie et classe).",
    cookieTitle: "Nous respectons votre vie privée",
    cookieText: "Nous utilisons des cookies techniques nécessaires au fonctionnement du site et, avec votre consentement, des cookies de statistiques et d'amélioration.",
    cookieAccept: "Tout accepter",
    cookieReject: "Nécessaires seulement",
    contactTitle: "Une question ou une collaboration ?",
    contactSubtitle: "Écrivez-nous, nous vous répondrons rapidement.",
    contactName: "Nom",
    contactEmail: "Votre e-mail",
    contactCompany: "Entreprise (facultatif)",
    contactMessage: "Message",
    contactSend: "Envoyer le message",
    contactSending: "Envoi...",
    contactSuccess: "Message envoyé ! Nous vous répondrons bientôt.",
    contactError: "Échec de l'envoi. Réessayez.",
    contactCta: "Nous contacter",
    subtitle: "Choisis deux produits et découvre lequel est vraiment avantageux, rendement et coûts à l'appui.",
    compare: "Comparer",
    catalog: "Catalogue",
    datasheetMissing: "Fiche technique manquante",
    category: "Domaine",
    subcategory: "Sous-catégorie",
    brand: "Marque",
    product: "Produit",
    selectPlaceholder: "Sélectionner…",
    filtersTitle: "Filtres rapides",
    filtersHint: "Touchez les filtres pour affiner la liste. La sélection manuelle reste possible.",
    fInterno: "Intérieur",
    fEsterno: "Extérieur",
    fClasse: "Classe S1/S2",
    fRapido: "Rapide",
    fRapidaAsc: "Séchage rapide",
    fPompabile: "Pompable",
    fUV: "Résistant UV",
    fBicomp: "Bicomposant",
    fFlex: "Flexible",
    fThickness: "Épaisseur (mm)",
    fResults: "produits",
    noMatch: "Aucun produit ne correspond aux critères sélectionnés",
    clearFilters: "Réinitialiser les filtres",
    productA: "Produit A",
    productB: "Produit B",
    addMissing: "Produit manquant ? Charger la fiche technique",
    addMissingHint: "L'IA lit le PDF et extrait les données automatiquement.",
    uploadTitle: "Charger une fiche technique",
    fabAddDatasheet: "Ajouter une fiche technique",
    multiUseLabel: "Usages multiples détectés",
    removeUse: "Retirer cet usage",
    uploadHint: "L'IA lit le PDF ou l'image (dans n'importe quelle langue) et extrait les données automatiquement. Si une donnée manque, Gemini la déduit de ses connaissances du produit (à vérifier).",
    uploadDrop: "Glisse le fichier ici ou clique pour sélectionner",
    uploadFormats: "PDF, PNG, JPG",
    extracting: "Lecture de la fiche avec Gemini…",
    reviewExtracted: "Vérifie et corrige les données extraites",
    saveProduct: "Enregistrer le produit",
    cancel: "Annuler",
    fileRequired: "Sélectionne d'abord un fichier",
    extractError: "Extraction échouée. Réessaie avec un fichier plus lisible.",
    savedOk: "Produit enregistré dans le catalogue",
    aiEstimatedHint: "Certaines valeurs surlignées sont des ESTIMATIONS (absentes de la fiche, déduites de prix du marché en ligne) : à vérifier.",
    dupSimilar: "Produit SIMILAIRE déjà présent :",
    dupWarn: "Un produit similaire existe déjà :",
    autoCategory: "Catégorie attribuée automatiquement",
    editCategoryHint: "modifiable si nécessaire",
    chooseForQuote: "Choisir pour le devis",
    comparison: "Comparaison",
    winner: "Meilleur",
    difference: "Différence",
    savings: "Économie",
    saveOf: "d'économie",
    parameters: "Paramètres de calcul",
    metratura: "Surface à poser",
    laborSection: "Coûts de pose (optionnels · défaut 0)",
    spessore2mani: "Épaisseur 2 couches",
    pricePerKg: "Prix au kg",
    useForQuote: "Utiliser pour le devis",
    costBreakdown: "Détail des coûts",
    quoteRecapTitle: "Produit sélectionné",
    consumptionTitle: "Détails de consommation",
    quoteEmptyTitle: "Aucun produit sélectionné",
    quoteEmptyBody: "Sélectionnez un produit ci-dessus pour calculer les quantités selon les m².",
    goToComparator: "Aller au comparateur",
    marketPriceHint: "Modifiez le prix selon le marché actuel.",
    consumption: "Consommation",
    bagWeight: "Poids de l'emballage",
    advanced: "Paramètres de chantier",
    salary: "Main-d'œuvre",
    transportMin: "Déplacement des sacs",
    mixingMin: "Malaxage",
    palletMin: "Transport depuis le dépôt",
    bagsPerPallet: "Sacs par palette",
    productCost: "Coût du produit",
    transportCost: "Déplacement des sacs",
    mixingCost: "Malaxage",
    palletCost: "Transport depuis le dépôt",
    costComposition: "Composition du coût",
    descMetratura: "Surface totale à revêtir.",
    descSalary: "Prix horaire moyen qu'une entreprise paie à son propre ouvrier.",
    descTransport: "Temps pour amener chaque sac au point de pose.",
    descMixing: "Temps pour malaxer chaque sac.",
    descPallet: "Temps pour déplacer les palettes depuis le dépôt.",
    readonlyHint: "Données fixes du produit (non modifiables)",
    trowel: "Truelle",
    trowelDesc: "Denture de la truelle : modifie la consommation (base 6 mm).",
    tileA: "Côté A carreau",
    tileB: "Côté B carreau",
    tileThickness: "Épaisseur carreau",
    jointWidth: "Largeur du joint",
    groutDesc: "Géométrie du carreau et du joint : calcule les kg de mortier nécessaires.",
    groutJoint: "joint",
    interpolated: "interpolé",
    unitCm: "Centimètres",
    navQuote: "Choisir le produit",
    quoteTitle: "Choisir le produit",
    quoteSubtitle: "Vous savez déjà quel produit ? Sélectionnez-le et calculez les quantités selon les m². Mêmes infos que la comparaison, sans graphiques.",
    shareTitle: "Partager les résultats / Envoyer la commande",
    shareHint: "Remplissez les données : téléchargez le PDF et, si vous saisissez l'e-mail du destinataire, il en recevra une copie.",
    fCompany: "Entreprise / artisan *",
    fProject: "Projet / chantier *",
    fCityZip: "Ville ou NPA du chantier *",
    fRecipient: "E-mail destinataire (client/revendeur) — optionnel",
    fNotes: "Notes supplémentaires (optionnel)",
    btnSend: "Envoyer et télécharger le PDF",
    shareRequired: "Remplissez entreprise, projet et ville/NPA.",
    disclaimerShort: "Données saisies par les utilisateurs pour les utilisateurs. Aucune responsabilité pour erreurs de calcul.",
    copyright: "© 2026 METEROX. Propriété intellectuelle exclusive. Tous droits réservés.",
    dsView: "Voir/Télécharger",
    dsReplace: "Remplacer",
    dsAttach: "Joindre la fiche",
    navLeads: "Leads",
    leadsTitle: "Leads & devis collectés",
    leadsEmpty: "Aucun lead pour l'instant.",
    thDate: "Date",
    thCompany: "Entreprise",
    thProject: "Projet",
    thCity: "Ville/NPA",
    thQty: "Quantité",
    thEmail: "Destinataire",
    viewLeads: "Leads",
    viewProducts: "Produits",
    viewContacts: "Messages",
    contactsTitle: "Messages reçus",
    contactsEmpty: "Aucun message reçu.",
    toastSent: "Envoyé et PDF téléchargé",
    toastDownloaded: "PDF téléchargé",
    markup: "Marge artisan (%)",
    clientPrice: "Prix client",
    quoteExportTitle: "Exporter le devis PDF",
    quoteExportHint: "Saisissez les données du projet pour générer le PDF.",
    projectName: "Nom du projet",
    zip: "NPA",
    city: "Ville",
    exportQuotePdf: "Exporter le devis PDF",
    quoteLeadRequired: "Remplissez Nom, NPA et Ville pour débloquer le PDF.",
    quoteDetail: "Détail de l'offre",
    quoteDisclaimer: "Les consommations sont théoriques, hors chutes de chantier. Quantités et prix réels variables. Devis indicatif, non contractuel.",
    areaCalcTitle: "Calculer la surface",
    areaCalcHint: "Ajoutez une pièce par espace (ex. Cuisine, Salon). Pour les pièces en L, ajoutez des sections. Mesurez chaque pièce en AR.",
    roomLabel: "Pièce",
    roomNamePlaceholder: "Nom de la pièce (ex. Cuisine)",
    roomsSummary: "Récapitulatif des pièces",
    addRoom: "Ajouter une pièce",
    measureRoomAR: "Mesurer en AR",
    arMeasured: "Mesuré en AR",
    width: "Largeur (m)",
    length: "Longueur (m)",
    addSection: "Ajouter une zone",
    totalArea: "Surface totale",
    useArea: "Utiliser cette surface",
    smartArea: "Mesurer au smartphone",
    arScan: "Scanner avec la caméra",
    arScanHint: "Placez les points au sol (appareils Android compatibles).",
    arInstr: "Visez les coins du sol et touchez « Ajouter un point »",
    arScanning: "Déplacez lentement le téléphone pour détecter le sol…",
    arLost: "Déplacez lentement le téléphone vers le sol",
    arAddPoint: "Ajouter un point",
    exitAr: "Sortir",
    undoAr: "Annuler",
    arFinish: "Terminer",
    arCancel: "Annuler",
    arError: "AR non disponible sur cet appareil.",
    arComingSoon: "Scan AR bientôt — utilisez le calculateur ci-dessous.",
    product: "Produit",
    base_legante: "Base liante",
    base_chimica: "Base chimique",
    tipologia: "Type",
    diluizione: "Dilution",
    consistenza: "Consistance",
    comportamento_elastico: "Comportement élastique",
    funzione: "Fonction",
    modulo_elastico: "Module élastique",
    shore_a: "Dureté Shore A",
    capacita_movimento: "Capacité de mouvement",
    gel_time_min: "Temps de gel",
    indurimento: "Durcissement",
    larghezza_rotolo: "Largeur du rouleau",
    spessore_telo: "Épaisseur",
    pompabile: "Pompable",
    pendenze: "Formation de pentes",
    idrorepellente: "Hydrofuge / Anti-moisissure",
    piscine: "Piscines / Alimentaire",
    fondi_assorbenti: "Supports absorbants",
    fondi_non_assorbenti: "Supports non absorbants",
    barriera_vapore: "Barrière vapeur",
    fibrorinforzato: "Fibré",
    packTitle: "Comparaison par conditionnement",
    packQty: "Quantité de travail",
    packQtyDesc: "Surface, mètres linéaires ou pièces à couvrir.",
    packPrice: "Prix du conditionnement",
    coveragePerPack: "Rendement par conditionnement",
    packsNeeded: "Conditionnements nécessaires",
    costPerUnit: "Coût par unité",
    packUnitPz: "cond.",
    packDiffUnit: "Les deux produits ont des unités différentes : la comparaison directe n'est pas possible.",
    finalCost: "Coût final",
    unitM2: "Mètres carrés",
    unitChfHour: "CHF par heure",
    unitMinBag: "Minutes par sac",
    unitMinPallet: "Minutes par palette",
    unitMm: "Millimètres (denture)",
    unitMmFull: "Millimètres",
    loginTitle: "Accès réservé",
    loginRequired: "Seul le propriétaire peut modifier ou supprimer les produits. Connecte-toi pour continuer.",
    email: "E-mail",
    password: "Mot de passe",
    loginBtn: "Se connecter",
    loginError: "Identifiants invalides",
    logout: "Déconnexion",
    loggedInAs: "Connecté en tant que",
    versusTitle: "Comparaison des caractéristiques",
    lowerBetter: "moins c'est mieux",
    higherBetter: "plus c'est mieux",
    versusWins: "Gagne sur",
    winsUnit: "caract.",
    equivSame: "Les deux produits sont techniquement équivalents et comparables.",
    equivDiff: "Attention : les produits ne sont pas totalement équivalents",
    reasonType: "typologie différente",
    reasonRes: "classe de performance différente",
    reasonRapid: "prise rapide différente",
    reasonComp: "composants différents (mono/bi)",
    suggestSimilar: "Produit le plus proche de",
    useThis: "Utiliser celui-ci",
    radarTitle: "Radar des caractéristiques",
    totalCost: "Coût total",
    costPerM2: "Coût au m²",
    bagsNeeded: "Emballages nécessaires",
    totalKg: "Kg totaux",
    resa: "Rendement (m²/emb.)",
    techData: "Données techniques",
    yieldTitle: "Comment nous calculons le rendement",
    yieldSubtitle: "À partir des données de la fiche technique, traduites et clarifiées.",
    yieldFormulaLabel: "Calcul de la consommation",
    consumoTeoricoMm: "Consommation théorique (kg/m²/mm)",
    coefDenti: "Coeff. dents",
    coefInclinazione: "Coeff. inclinaison",
    teethShort: "dents",
    inclShort: "inclinaison",
    fromDatasheet: "d'après la fiche technique",
    forArea: "Pour",
    unitPackShort: "emb.",
    yieldManual: "rendement selon la fiche",
    noteConsumoTitle: "Note de la fiche (traduite)",
    note_consumo: "Note consommation/rendement",
    resistenza: "Déformabilité",
    certificazioni: "Certifications",
    colore: "Couleur",
    application: "Usages",
    interno: "Intérieur",
    esterno: "Extérieur",
    ambito: "Domaine d'emploi",
    ambitoIntExt: "Intérieur + Extérieur",
    ambitoInt: "Intérieur uniquement",
    applicazione: "Application",
    posPavimento: "Sol",
    posParete: "Mur",
    posSoffitto: "Plafond",
    serpentine: "Plancher chauffant",
    acqua: "Eau de gâchage (l)",
    rapida: "Prise rapide",
    ceramica: "Céramique",
    mosaico: "Mosaïque",
    pietra_naturale: "Pierre naturelle",
    parquet: "Parquet",
    pareti: "Murs",
    pavimenti: "Sols",
    soffitto: "Plafond",
    spessore: "Épaisseur (mm)",
    lavorabilita: "Temps ouvert (min)",
    pedonabile: "Praticable (h)",
    axResMpa: "Résistance (MPa)",
    axThickMm: "Épaisseur max (mm)",
    rAxYield: "Rendement",
    rAxConsumo: "Conso.",
    rAxWork: "Temps ouv.",
    rAxWalk: "Praticable",
    rAxRes: "Résistance",
    rAxThick: "Épaisseur",
    axElasticita: "Élasticité (Classe S)",
    axDensita: "Densité (kg/dm³)",
    rAxElast: "Élasticité",
    rAxDens: "Densité",
    noData: "Donnée non déclarée",
    densita: "Densité (kg/dm³)",
    maniProdotto: "Nombre de couches",
    attesaPiastrelle: "Attente carreaux (jours)",
    attesaParquet: "Attente parquet (jours)",
    allungamento: "Allongement (%)",
    classeRipristino: "Classe de réparation",
    yes: "Oui",
    no: "Non",
    chatTitle: "Assistant technique",
    chatHint: "Demande tout sur les fiches enregistrées — même des données hors tableau.",
    chatPlaceholder: "Ex. quel produit convient sur support humide ?",
    send: "Envoyer",
    thinking: "Je consulte les fiches…",
    chatIntro: "Bonjour ! Je réponds à partir des données techniques des produits en archive. Comment aider sur le chantier ?",
    emptyTitle: "Sélectionne deux produits à comparer",
    emptyBody: "Utilise les sélecteurs ci-dessus. Si un produit manque, charge sa fiche technique.",
    incomplete: "Données insuffisantes pour le calcul",
    incompleteBody: "Ce produit n'a pas encore de rendement ni de prix. Modifie les champs ci-dessous ou recharge la fiche.",
    editable: "modifiable",
    reset: "Réinitialiser",
    priceBag: "Prix par emballage",
    editHint: "Champs modifiables",
    navCompare: "Comparer",
    navCatalog: "Catalogue",
    navMeasure: "Mesurer surface",
    navSpecs: "Analyse Cahiers",
    navSystems: "Systèmes Certifiés",
    stratTitle: "Configurateur de Système de Sol",
    stratSubtitle: "Stratigraphie certifiée {brand} · quantités et prix selon fiche technique",
    stratQuotaTot: "Hauteur totale (carreau inclus, mm)",
    stratTileThk: "Épaisseur carreau (mm)",
    stratArea: "Surface (m²)",
    stratBase: "Support",
    stratAutolivellante: "Autolissant",
    stratMassetto: "Chape",
    stratInvalid: "La hauteur disponible est insuffisante pour les épaisseurs définies. Réduisez la colle/primaire ou augmentez la hauteur.",
    stratViewTitle: "Stratigraphie · vue éclatée",
    stratQuota: "Hauteur",
    stratHint: "Survolez ou cliquez une couche pour ouvrir la fiche technique",
    stratLayerTile: "Carreau",
    stratLayerColla: "Colle",
    stratLayerPrimer: "Primaire de fond",
    stratLayerSubstrate: "Support brut",
    stratLayerSerpentine: "Serpentins",
    stratPrimerToggle: "Primaire de fond sur support brut",
    stratNotAlways: "(pas toujours nécessaire)",
    stratOptional: "(optionnel)",
    stratPrecolla: "Primaire pré-colle",
    stratColla: "Colle à carrelage",
    stratThkCalc: "(épaisseur calculée)",
    stratFieldProduct: "Produit",
    stratFieldThk: "Épaisseur",
    stratFieldPriceKg: "Prix au kg",
    stratNoProduct: "— aucun produit —",
    stratOther: "AUTRE MATÉRIAU (valeur 0)",
    stratSysTitle: "Choisir le système",
    stratSysTilesPci: "Carrelage PCI",
    stratSysTilesSika: "Carrelage Sika",
    stratBag: "sac",
    stratKgNeeded: "kg nécessaires",
    stratLeftover: "reste",
    stratLeftoverShort: "reste",
    stratNoConstraint: "Aucune contrainte d'épaisseur",
    stratOutRange: "Hors plage",
    stratAtLimit: "À la limite",
    stratNearLimit: "Proche de la limite",
    stratCompatible: "Compatible",
    stratHeatingToggle: "Serpentins chauffage au sol",
    stratPipeDia: "Ø tube (mm)",
    stratPipeSpacing: "Entraxe (mm)",
    stratLeveler: "autolissant",
    stratPipeSaving: "Serpentins Ø{dia}mm · entraxe {spacing}mm → ~{eq} mm d'autolissant en moins par m² (matériau réduit automatiquement)",
    stratPrecollaToggle: "Ajouter primaire pré-colle",
    stratAddPrecolla: "Ajouter primaire pré-colle",
    stratRmPrecolla: "Retirer primaire pré-colle",
    stratAddHeating: "Ajouter serpentins chauffage",
    stratRmHeating: "Retirer serpentins chauffage",
    stratAddPrimer: "Ajouter primaire de fond",
    stratRmPrimer: "Retirer primaire de fond",
    stratPhotoTitle: "Photo support (opt.)",
    stratUploadPhoto: "Charger une photo",
    stratAnalyze: "Analyser et suggérer le primaire",
    stratAnalyzing: "Analyse en cours…",
    stratChange: "Changer",
    stratRemove: "Supprimer",
    stratAnalysisDone: "Analyse terminée",
    stratAnalysisFail: "Échec de l'analyse",
    stratSubstrateLbl: "Support :",
    stratPrimerRecommended: "Primaire conseillé :",
    stratTotal: "Total système",
    stratGenPDF: "Générer le PDF",
    stratGroutTitle: "Mortiers de Jointoiement",
    stratGroutTileL: "Longueur carreau (cm)",
    stratGroutTileW: "Largeur carreau (cm)",
    stratGroutJoint: "Largeur du joint (mm)",
    stratGroutResult: "Besoin en mortier de jointoiement",
    stratGroutReuse: "Épaisseur et surface repris du configurateur",
    stratDatasheetDefault: "Fiche technique produit",
    stratDsCategory: "Catégorie",
    stratDsResistance: "Résistance",
    stratDsConsumption: "Consommation",
    stratDsYield: "Rendement",
    stratDsPackage: "Conditionnement",
    stratDsThickness: "Épaisseur",
    stratDsWorkability: "Temps de travail",
    stratDsWalkable: "Praticable",
    stratDsPriceKg: "Prix/kg",
    stratDsColor: "Couleur",
    stratDsCerts: "Certifications",
    stratDsFeatures: "Caractéristiques",
    stratFlagRapid: "Rapide",
    stratFlagInterior: "Intérieur",
    stratFlagExterior: "Extérieur",
    stratPdfHeader: "Configurateur de Système de Sol · {brand}",
    stratPdfQuota: "Hauteur totale",
    stratPdfTile: "Carreau",
    stratPdfArea: "Surface",
    stratColLayer: "Couche",
    stratColProduct: "Produit",
    stratColThk: "Épaisseur",
    stratColCompat: "Compatibilité",
    stratColQty: "Quantité",
    stratColSubtotal: "Sous-total",
    stratCompatOK: "OK",
    stratCompatLimit: "LIMITE",
    stratCompatOut: "HORS PLAGE",
    stratPdfTotal: "TOTAL SYSTÈME",
    stratPdfDisclaimer: "Prix indicatifs hors TVA. Quantités calculées selon les rendements de la fiche technique PCI.",
    sysTitle: "Configurateur de Systèmes Intelligents (Vision 2026)",
    sysBadge: "Prochaine Implémentation",
    sysSub: "Un seul configurateur pour tout le système de pose, de la couche de fond à la finition.",
    sysStep1: "Saisie Chantier",
    sysStep1d: "Chargez des photos du support, saisissez les m² et la hauteur totale disponible (mm).",
    sysStep2: "Objectif Final",
    sysStep2d: "Sélectionnez la marque (Sika, PCI...) et le type de revêtement : carrelage, parquet ou résines industrielles.",
    sysStep3: "Calcul Stratigraphique",
    sysStep3d: "L'IA élabore le système complet en répartissant la hauteur disponible entre les couches nécessaires.",
    sysStrati: "Exemple de stratigraphie",
    sysLayer4: "Revêtement final",
    sysLayer4d: "ex. carrelage / parquet",
    sysLayer3: "Colle / Adhésif",
    sysLayer3d: "calculé automatiquement",
    sysLayer2: "Ragréage / Autolissant",
    sysLayer2d: "calculé pour compenser la hauteur",
    sysLayer1: "Primaire",
    sysLayer1d: "spécifique au support photographié",
    sysValueTitle: "Avantages",
    sysValue1: "Vente du système complet",
    sysValue2: "Garantie technique certifiée",
    sysValue3: "Zéro erreur de pose",
    sysDesc: "Sélectionnez votre objectif de chantier. METEROX configurera automatiquement le système complet certifié Sika/PCI/Schönox pour chaque application :",
    sysSelector: "Choisir la Technologie (Carrelage, Parquet, Résines...)",
    sysT1: "Carrelage & Pierres",
    sysT1d: "Supports, membranes, colles et joints.",
    sysT2: "Parquet & sols souples",
    sysT2d: "Barrières vapeur, ragréages et colles spécifiques.",
    sysT3: "Résines Industrielles",
    sysT3d: "Primaires, couches de fond et finitions protectrices.",
    sysT4: "Réparation & Routes",
    sysT4d: "Systèmes de protection des armatures et mortiers structurels.",
    sysTooltip: "Cette fonctionnalité sera disponible dans la prochaine mise à jour",
    specsTitle: "Analyse Intelligente des Cahiers des Charges (Bêta)",
    specsDesc: "Importez vos fichiers PDF ou Excel. L'intelligence artificielle de METEROX analysera les postes du cahier des charges et suggérera automatiquement les produits Sika équivalents avec leurs coûts actualisés.",
    specsComingSoon: "BIENTÔT DISPONIBLE",
    specsUpload: "Importer le cahier",
    specsTooltip: "Cette fonctionnalité sera disponible dans la prochaine mise à jour",
    specsStep1: "Importer le cahier",
    specsStep1d: "PDF ou Excel avec les postes",
    specsStep2: "Analyse IA",
    specsStep2d: "Reconnaissance automatique des postes",
    specsStep3: "Produits équivalents",
    specsStep3d: "Match Sika + coûts actualisés",
    measureTitle: "Mesurer la surface des pièces",
    measureBody: "Mesurez rapidement la surface avec la caméra (AR) ou en saisissant les dimensions. Ajoutez plusieurs pièces, puis confirmez : vous irez directement à « Choisir le produit » avec les m² déjà remplis.",
    measureStart: "Démarrer la mesure",
    measureFab: "Mesurer surface",
    measureReady: "Surface prête",
    measurePickHint: "Choisissez le produit ci-dessous : la surface est déjà définie.",
    manageTitle: "Gestion des produits",
    manageHint: "Modifier ou supprimer les produits de l'archive.",
    search: "Rechercher un produit ou une marque…",
    allBrands: "Toutes les marques",
    edit: "Modifier",
    del: "Supprimer",
    deleteConfirm: "Supprimer ce produit ?",
    deleteConfirmBody: "L'action est définitive et irréversible.",
    save: "Enregistrer",
    completeBadge: "Complet",
    incompleteBadge: "Incomplet",
    completeOk: "Produit complet — coche verte active",
    completeReqTitle: "Pour la coche verte, il manque encore :",
    exportPdf: "Exporter PDF",
    noResults: "Aucun produit trouvé",
    lockInfo: "Même domaine que le Produit A — choisis sous-catégorie, marque et produit.",
    productsCount: "produits",
  },
  en: {
    tagline: "The Digital Ecosystem for Professionals",
    bestMatch: "Best Match",
    techEquivalent: "Technical Equivalent",
    matchInfo: "These products were matched by similar technical features (subcategory and class).",
    cookieTitle: "We respect your privacy",
    cookieText: "We use technically necessary cookies and, with your consent, cookies for statistics and to improve your experience.",
    cookieAccept: "Accept all",
    cookieReject: "Necessary only",
    contactTitle: "Questions or partnership?",
    contactSubtitle: "Write to us — we'll get back to you shortly.",
    contactName: "Name",
    contactEmail: "Your email",
    contactCompany: "Company (optional)",
    contactMessage: "Message",
    contactSend: "Send message",
    contactSending: "Sending...",
    contactSuccess: "Message sent! We'll reply soon.",
    contactError: "Sending failed. Please try again.",
    contactCta: "Contact us",
    subtitle: "Pick two products and find out which one truly pays off — yield and costs included.",
    compare: "Compare",
    catalog: "Catalog",
    datasheetMissing: "Datasheet missing",
    category: "Area",
    subcategory: "Subcategory",
    brand: "Brand",
    product: "Product",
    selectPlaceholder: "Select…",
    filtersTitle: "Quick filters",
    filtersHint: "Tap the filters to narrow the list. Manual selection is always available.",
    fInterno: "Indoor",
    fEsterno: "Outdoor",
    fClasse: "Class S1/S2",
    fRapido: "Fast",
    fRapidaAsc: "Fast drying",
    fPompabile: "Pumpable",
    fUV: "UV resistant",
    fBicomp: "Two-component",
    fFlex: "Flexible",
    fThickness: "Thickness (mm)",
    fResults: "products",
    noMatch: "No product matches the selected criteria",
    clearFilters: "Clear filters",
    productA: "Product A",
    productB: "Product B",
    addMissing: "Product missing? Upload the technical data sheet",
    addMissingHint: "AI reads the PDF and extracts the data automatically.",
    uploadTitle: "Upload data sheet",
    fabAddDatasheet: "Add Data Sheet",
    multiUseLabel: "Multiple uses detected",
    removeUse: "Remove this use",
    uploadHint: "The AI reads the PDF or image (in any language) and extracts the data automatically. If a value is missing from the sheet, Gemini infers it from its product knowledge (please verify).",
    uploadDrop: "Drag the file here or click to select",
    uploadFormats: "PDF, PNG, JPG",
    extracting: "Reading the data sheet with Gemini…",
    reviewExtracted: "Review and correct the extracted data",
    saveProduct: "Save product",
    cancel: "Cancel",
    fileRequired: "Select a file first",
    extractError: "Extraction failed. Try again with a clearer file.",
    savedOk: "Product saved to catalog",
    aiEstimatedHint: "Some highlighted values are ESTIMATES (not in the datasheet, inferred from online market prices): please verify.",
    dupSimilar: "SIMILAR product already exists:",
    dupWarn: "A similar product already exists:",
    autoCategory: "Automatically assigned category",
    editCategoryHint: "editable if needed",
    chooseForQuote: "Choose this for quote",
    comparison: "Comparison",
    winner: "Best",
    difference: "Difference",
    savings: "Savings",
    saveOf: "saved",
    parameters: "Calculation parameters",
    metratura: "Surface to lay",
    laborSection: "Installation costs (optional · default 0)",
    spessore2mani: "Thickness 2 coats",
    pricePerKg: "Price per kg",
    useForQuote: "Use for quote",
    costBreakdown: "Cost breakdown",
    quoteRecapTitle: "Selected product",
    consumptionTitle: "Consumption details",
    quoteEmptyTitle: "No product selected",
    quoteEmptyBody: "Select a product above to calculate quantities by m².",
    goToComparator: "Go to comparator",
    marketPriceHint: "Adjust the price to the current market.",
    consumption: "Consumption",
    bagWeight: "Pack weight",
    advanced: "Site parameters",
    salary: "Labour",
    transportMin: "Bag handling",
    mixingMin: "Mixing",
    palletMin: "Warehouse handling",
    bagsPerPallet: "Bags per pallet",
    productCost: "Product cost",
    transportCost: "Bag handling",
    mixingCost: "Mixing",
    palletCost: "Warehouse handling",
    costComposition: "Cost composition",
    descMetratura: "Total surface to cover.",
    descSalary: "Average hourly rate a company pays its own worker.",
    descTransport: "Time to move each bag to the laying spot.",
    descMixing: "Time to mix each bag.",
    descPallet: "Time to move pallets from the warehouse.",
    readonlyHint: "Fixed product data (not editable)",
    trowel: "Trowel",
    trowelDesc: "Trowel notch size: changes consumption (base 6 mm).",
    tileA: "Tile side A",
    tileB: "Tile side B",
    tileThickness: "Tile thickness",
    jointWidth: "Joint width",
    groutDesc: "Tile and joint geometry: computes the kg of grout needed.",
    groutJoint: "joint",
    interpolated: "interpolated",
    unitCm: "Centimetres",
    navQuote: "Choose product",
    quoteTitle: "Choose product",
    quoteSubtitle: "Already know which product? Select it and calculate quantities by m². Same info as the comparison, without charts.",
    shareTitle: "Share results / Send order",
    shareHint: "Fill in the details: download the PDF and, if you enter the recipient email, they'll get a copy.",
    fCompany: "Company / contractor *",
    fProject: "Project / site *",
    fCityZip: "Site city or ZIP *",
    fRecipient: "Recipient email (client/reseller) — optional",
    fNotes: "Additional notes (optional)",
    btnSend: "Send and download PDF",
    shareRequired: "Fill in company, project and city/ZIP.",
    disclaimerShort: "Data entered by users for users. No liability for calculation errors.",
    copyright: "© 2026 METEROX. Exclusive intellectual property. All rights reserved.",
    dsView: "View/Download",
    dsReplace: "Replace",
    dsAttach: "Attach datasheet",
    navLeads: "Leads",
    leadsTitle: "Collected leads & quotes",
    leadsEmpty: "No leads yet.",
    thDate: "Date",
    thCompany: "Company",
    thProject: "Project",
    thCity: "City/ZIP",
    thQty: "Quantity",
    thEmail: "Recipient",
    viewLeads: "Leads",
    viewProducts: "Products",
    viewContacts: "Messages",
    contactsTitle: "Received messages",
    contactsEmpty: "No messages received.",
    toastSent: "Sent and PDF downloaded",
    toastDownloaded: "PDF downloaded",
    markup: "Contractor markup (%)",
    clientPrice: "Client price",
    quoteExportTitle: "Export Quote PDF",
    quoteExportHint: "Enter project data to generate the quote PDF.",
    projectName: "Project name",
    zip: "ZIP",
    city: "City",
    exportQuotePdf: "Export Quote PDF",
    quoteLeadRequired: "Fill Project, ZIP and City to unlock the PDF.",
    quoteDetail: "Quote detail",
    quoteDisclaimer: "Consumption values are theoretical and exclude site waste. Real quantities and prices may vary. Indicative, non-binding quote.",
    areaCalcTitle: "Calculate Area",
    areaCalcHint: "Add a room for each space (e.g. Kitchen, Living room). For L-shaped rooms, add sections. Measure each room with AR.",
    roomLabel: "Room",
    roomNamePlaceholder: "Room name (e.g. Kitchen)",
    roomsSummary: "Rooms summary",
    addRoom: "Add room",
    measureRoomAR: "Measure with AR",
    arMeasured: "Measured with AR",
    width: "Width (m)",
    length: "Length (m)",
    addSection: "Add section",
    totalArea: "Total area",
    useArea: "Use this area",
    smartArea: "Measure with phone",
    arScan: "Scan with camera",
    arScanHint: "Place points on the floor (compatible Android devices).",
    arInstr: "Aim at the floor corners and tap «Add point»",
    arScanning: "Move the phone slowly to detect the floor…",
    arLost: "Slowly move the phone toward the floor",
    arAddPoint: "Add point",
    exitAr: "Exit",
    undoAr: "Undo",
    arFinish: "Done",
    arCancel: "Cancel",
    arError: "AR not available on this device.",
    arComingSoon: "AR scan coming soon — use the calculator below.",
    product: "Product",
    base_legante: "Binder base",
    base_chimica: "Chemical base",
    tipologia: "Type",
    diluizione: "Dilution",
    consistenza: "Consistency",
    comportamento_elastico: "Elastic behavior",
    funzione: "Function",
    modulo_elastico: "Elastic modulus",
    shore_a: "Shore A hardness",
    capacita_movimento: "Movement capability",
    gel_time_min: "Gel time",
    indurimento: "Full curing",
    larghezza_rotolo: "Roll width",
    spessore_telo: "Thickness",
    pompabile: "Machine pumpable",
    pendenze: "Slope forming",
    idrorepellente: "Water-repellent / Anti-mould",
    piscine: "Pools / Food-contact",
    fondi_assorbenti: "Absorbent substrates",
    fondi_non_assorbenti: "Non-absorbent substrates",
    barriera_vapore: "Vapor barrier",
    fibrorinforzato: "Fiber-reinforced",
    packTitle: "Comparison per pack",
    packQty: "Job quantity",
    packQtyDesc: "Area, linear metres or pieces to cover.",
    packPrice: "Pack price",
    coveragePerPack: "Coverage per pack",
    packsNeeded: "Packs needed",
    costPerUnit: "Cost per unit",
    packUnitPz: "pcs",
    packDiffUnit: "The two products use different units: a direct comparison is not possible.",
    finalCost: "Final cost",
    unitM2: "Square metres",
    unitChfHour: "CHF per hour",
    unitMinBag: "Minutes per bag",
    unitMinPallet: "Minutes per pallet",
    unitMm: "Millimetres (notch)",
    unitMmFull: "Millimetres",
    loginTitle: "Restricted access",
    loginRequired: "Only the owner can edit or delete products. Please log in to continue.",
    email: "Email",
    password: "Password",
    loginBtn: "Log in",
    loginError: "Invalid credentials",
    logout: "Log out",
    loggedInAs: "Logged in as",
    versusTitle: "Feature comparison",
    lowerBetter: "lower is better",
    higherBetter: "higher is better",
    versusWins: "Wins on",
    winsUnit: "feats.",
    equivSame: "The two products are technically equivalent and comparable.",
    equivDiff: "Warning: the products are not fully equivalent",
    reasonType: "different type",
    reasonRes: "different performance class",
    reasonRapid: "different rapid setting",
    reasonComp: "different components (1K/2K)",
    suggestSimilar: "Most similar product from",
    useThis: "Use this",
    radarTitle: "Feature radar",
    totalCost: "Total cost",
    costPerM2: "Cost per m²",
    bagsNeeded: "Packs needed",
    totalKg: "Total kg",
    resa: "Yield (m²/pack)",
    techData: "Technical data",
    yieldTitle: "How we compute the yield",
    yieldSubtitle: "From the datasheet values, translated and made clear.",
    yieldFormulaLabel: "Consumption calculation",
    consumoTeoricoMm: "Theoretical consumption (kg/m²/mm)",
    coefDenti: "Trowel teeth coeff.",
    coefInclinazione: "Inclination coeff.",
    teethShort: "teeth",
    inclShort: "inclination",
    fromDatasheet: "from datasheet",
    forArea: "For",
    unitPackShort: "pack",
    yieldManual: "yield from datasheet",
    noteConsumoTitle: "Datasheet note (translated)",
    note_consumo: "Consumption/yield note",
    resistenza: "Deformability",
    certificazioni: "Certifications",
    colore: "Color",
    application: "Uses",
    interno: "Indoor",
    esterno: "Outdoor",
    ambito: "Application area",
    ambitoIntExt: "Indoor + Outdoor",
    ambitoInt: "Indoor only",
    applicazione: "Application",
    posPavimento: "Floor",
    posParete: "Wall",
    posSoffitto: "Ceiling",
    serpentine: "Underfloor heating",
    acqua: "Mixing water (l)",
    rapida: "Rapid setting",
    ceramica: "Ceramic",
    mosaico: "Mosaic",
    pietra_naturale: "Natural stone",
    parquet: "Parquet",
    pareti: "Walls",
    pavimenti: "Floors",
    soffitto: "Ceiling",
    spessore: "Thickness (mm)",
    lavorabilita: "Open time (min)",
    pedonabile: "Walkable (h)",
    axResMpa: "Resistance (MPa)",
    axThickMm: "Max thickness (mm)",
    rAxYield: "Yield",
    rAxConsumo: "Consumption",
    rAxWork: "Open time",
    rAxWalk: "Walkable",
    rAxRes: "Resistance",
    rAxThick: "Thickness",
    axElasticita: "Elasticity (Class S)",
    axDensita: "Density (kg/dm³)",
    rAxElast: "Elasticity",
    rAxDens: "Density",
    noData: "Not declared",
    densita: "Density (kg/dm³)",
    maniProdotto: "Number of coats",
    attesaPiastrelle: "Wait for tiles (days)",
    attesaParquet: "Wait for parquet (days)",
    allungamento: "Elongation (%)",
    classeRipristino: "Repair class",
    yes: "Yes",
    no: "No",
    chatTitle: "Technical assistant",
    chatHint: "Ask anything about the saved data sheets — even data not in the table.",
    chatPlaceholder: "E.g. which product suits a damp substrate?",
    send: "Send",
    thinking: "Consulting the data sheets…",
    chatIntro: "Hi! I answer based on the technical product data in the archive. How can I help on site?",
    emptyTitle: "Select two products to compare",
    emptyBody: "Use the selectors above. If a product is missing, upload its data sheet.",
    incomplete: "Not enough data to calculate",
    incompleteBody: "This product has no yield and price yet. Edit the fields below or re-upload the data sheet.",
    editable: "editable",
    reset: "Reset",
    priceBag: "Price per pack",
    editHint: "Editable fields",
    navCompare: "Compare",
    navCatalog: "Catalog",
    navMeasure: "Measure area",
    navSpecs: "Specs Analysis",
    navSystems: "Certified Systems",
    stratTitle: "Floor System Configurator",
    stratSubtitle: "Certified {brand} build-up · quantities and prices from datasheet",
    stratQuotaTot: "Total height (tile incl., mm)",
    stratTileThk: "Tile thickness (mm)",
    stratArea: "Surface (m²)",
    stratBase: "Substrate",
    stratAutolivellante: "Self-leveller",
    stratMassetto: "Screed",
    stratInvalid: "The available height is insufficient for the set thicknesses. Reduce adhesive/primer or increase the height.",
    stratViewTitle: "Stratigraphy · exploded view",
    stratQuota: "Height",
    stratHint: "Hover or click a layer to open the datasheet",
    stratLayerTile: "Tile",
    stratLayerColla: "Adhesive",
    stratLayerPrimer: "Base primer",
    stratLayerSubstrate: "Raw substrate",
    stratLayerSerpentine: "Heating pipes",
    stratPrimerToggle: "Base primer on raw substrate",
    stratNotAlways: "(not always needed)",
    stratOptional: "(optional)",
    stratPrecolla: "Pre-adhesive primer",
    stratColla: "Tile adhesive",
    stratThkCalc: "(calculated thickness)",
    stratFieldProduct: "Product",
    stratFieldThk: "Thickness",
    stratFieldPriceKg: "Price per kg",
    stratNoProduct: "— no product —",
    stratOther: "OTHER MATERIAL (value 0)",
    stratSysTitle: "Choose the system",
    stratSysTilesPci: "PCI Tiles",
    stratSysTilesSika: "Sika Tiles",
    stratBag: "bag",
    stratKgNeeded: "kg needed",
    stratLeftover: "leftover",
    stratLeftoverShort: "leftover",
    stratNoConstraint: "No thickness constraint",
    stratOutRange: "Out of range",
    stratAtLimit: "At the limit",
    stratNearLimit: "Near the limit",
    stratCompatible: "Compatible",
    stratHeatingToggle: "Underfloor heating pipes",
    stratPipeDia: "Ø pipe (mm)",
    stratPipeSpacing: "Spacing (mm)",
    stratLeveler: "leveller",
    stratPipeSaving: "Heating pipes Ø{dia}mm · spacing {spacing}mm → ~{eq} mm less leveller per m² (material reduced automatically)",
    stratPrecollaToggle: "Add pre-adhesive primer",
    stratAddPrecolla: "Add pre-adhesive primer",
    stratRmPrecolla: "Remove pre-adhesive primer",
    stratAddHeating: "Add underfloor heating pipes",
    stratRmHeating: "Remove underfloor heating pipes",
    stratAddPrimer: "Add base primer",
    stratRmPrimer: "Remove base primer",
    stratPhotoTitle: "Substrate photo (opt.)",
    stratUploadPhoto: "Upload photo",
    stratAnalyze: "Analyze and suggest primer",
    stratAnalyzing: "Analyzing…",
    stratChange: "Change",
    stratRemove: "Remove",
    stratAnalysisDone: "Analysis complete",
    stratAnalysisFail: "Analysis failed",
    stratSubstrateLbl: "Substrate:",
    stratPrimerRecommended: "Recommended primer:",
    stratTotal: "System total",
    stratGenPDF: "Generate PDF",
    stratGroutTitle: "Grout",
    stratGroutTileL: "Tile length (cm)",
    stratGroutTileW: "Tile width (cm)",
    stratGroutJoint: "Joint width (mm)",
    stratGroutResult: "Grout requirement",
    stratGroutReuse: "Thickness and surface taken from the configurator",
    stratDatasheetDefault: "Product datasheet",
    stratDsCategory: "Category",
    stratDsResistance: "Resistance",
    stratDsConsumption: "Consumption",
    stratDsYield: "Yield",
    stratDsPackage: "Packaging",
    stratDsThickness: "Thickness",
    stratDsWorkability: "Working time",
    stratDsWalkable: "Walkable",
    stratDsPriceKg: "Price/kg",
    stratDsColor: "Color",
    stratDsCerts: "Certifications",
    stratDsFeatures: "Features",
    stratFlagRapid: "Rapid",
    stratFlagInterior: "Interior",
    stratFlagExterior: "Exterior",
    stratPdfHeader: "Floor System Configurator · {brand}",
    stratPdfQuota: "Total height",
    stratPdfTile: "Tile",
    stratPdfArea: "Surface",
    stratColLayer: "Layer",
    stratColProduct: "Product",
    stratColThk: "Thickness",
    stratColCompat: "Compatibility",
    stratColQty: "Quantity",
    stratColSubtotal: "Subtotal",
    stratCompatOK: "OK",
    stratCompatLimit: "LIMIT",
    stratCompatOut: "OUT OF RANGE",
    stratPdfTotal: "SYSTEM TOTAL",
    stratPdfDisclaimer: "Indicative prices excl. VAT. Quantities calculated from PCI datasheet yields.",
    sysTitle: "Intelligent Systems Configurator (Vision 2026)",
    sysBadge: "Next Implementation",
    sysSub: "A single configurator for the whole installation system, from base layer to finish.",
    sysStep1: "Job-Site Input",
    sysStep1d: "Upload photos of the substrate, enter the m² and the total available height (mm).",
    sysStep2: "Final Goal",
    sysStep2d: "Select the brand (Sika, PCI...) and the covering type: tiles, parquet or industrial resins.",
    sysStep3: "Stratigraphic Calculation",
    sysStep3d: "The AI builds the complete system, splitting the available height across the needed layers.",
    sysStrati: "Example stratigraphy",
    sysLayer4: "Final covering",
    sysLayer4d: "e.g. tile / parquet",
    sysLayer3: "Adhesive / Glue",
    sysLayer3d: "automatically calculated",
    sysLayer2: "Leveller / Self-levelling",
    sysLayer2d: "calculated to compensate height",
    sysLayer1: "Primer",
    sysLayer1d: "specific to the photographed substrate",
    sysValueTitle: "Benefits",
    sysValue1: "Sell the complete system",
    sysValue2: "Certified technical guarantee",
    sysValue3: "Zero installation errors",
    sysDesc: "Select your job-site goal. METEROX will automatically configure the complete certified Sika/PCI/Schönox system for every application:",
    sysSelector: "Choose Technology (Tiles, Parquet, Resins...)",
    sysT1: "Tiles & Stone",
    sysT1d: "Substrates, membranes, adhesives and grouts.",
    sysT2: "Parquet & Resilient",
    sysT2d: "Vapor barriers, levellers and specific adhesives.",
    sysT3: "Industrial Resins",
    sysT3d: "Primers, base coats and protective finishes.",
    sysT4: "Repair & Roads",
    sysT4d: "Rebar protection systems and structural mortars.",
    sysTooltip: "This feature will be available in the next update",
    specsTitle: "Intelligent Specifications Analysis (Beta)",
    specsDesc: "Upload your PDF or Excel files. METEROX artificial intelligence will analyze the specification items and automatically suggest equivalent Sika products with up-to-date costs.",
    specsComingSoon: "COMING SOON",
    specsUpload: "Upload Specifications",
    specsTooltip: "This feature will be available in the next update",
    specsStep1: "Upload specs",
    specsStep1d: "PDF or Excel with the items",
    specsStep2: "AI analysis",
    specsStep2d: "Automatic item recognition",
    specsStep3: "Equivalent products",
    specsStep3d: "Sika match + updated costs",
    measureTitle: "Measure room area",
    measureBody: "Quickly measure the area with your camera (AR) or by entering dimensions. Add multiple rooms, then confirm: you'll go straight to Choose Product with the m² already filled in.",
    measureStart: "Start measuring",
    measureFab: "Measure area",
    measureReady: "Area ready",
    measurePickHint: "Pick the material below — the area is already set.",
    manageTitle: "Product management",
    manageHint: "Edit or delete products in the archive.",
    search: "Search product or brand…",
    allBrands: "All brands",
    edit: "Edit",
    del: "Delete",
    deleteConfirm: "Delete this product?",
    deleteConfirmBody: "This action is permanent and cannot be undone.",
    save: "Save",
    completeBadge: "Complete",
    incompleteBadge: "Incomplete",
    completeOk: "Product complete — green check active",
    completeReqTitle: "For the green check you still need:",
    exportPdf: "Export PDF",
    noResults: "No products found",
    lockInfo: "Same area as Product A — pick subcategory, brand and product.",
    productsCount: "products",
  },
};

// category / subcategory labels
const CAT = {
  preparazione_fondo: { it: "Preparazione del sottofondo", de: "Untergrundvorbereitung", fr: "Préparation du support", en: "Substrate preparation" },
  posa_piastrelle: { it: "Posa Piastrelle & Pietre", de: "Fliesen & Naturstein", fr: "Carrelage & pierres", en: "Tiling & stone" },
  impermeabilizzazione: { it: "Impermeabilizzazione", de: "Abdichtung", fr: "Étanchéité", en: "Waterproofing" },
  parquet_resilienti: { it: "Parquet & Resilienti", de: "Parkett & elastische Beläge", fr: "Parquet & sols souples", en: "Parquet & resilient" },
  ripristino: { it: "Ripristino strutturale e stradale", de: "Instandsetzung Bau & Strasse", fr: "Réparation structurelle & routière", en: "Structural & road repair" },

  autolivellanti: { it: "Autolivellanti", de: "Ausgleichsmassen", fr: "Ragréages autolissants", en: "Self-levelling" },
  massetti: { it: "Massetti", de: "Estriche", fr: "Chapes", en: "Screeds" },
  rasanti: { it: "Rasanti", de: "Spachtelmassen", fr: "Enduits de lissage", en: "Skim coats" },
  primer: { it: "Primer", de: "Grundierungen", fr: "Primaires", en: "Primers" },

  adesivi_standard: { it: "Adesivi standard e rapidi", de: "Standard- & Schnellkleber", fr: "Colles standard et rapides", en: "Standard & rapid adhesives" },
  adesivi_rapidi: { it: "Adesivi Rapidi", de: "Schnellkleber", fr: "Colles rapides", en: "Rapid adhesives" },
  adesivi_reattivi: { it: "Adesivi speciali e reattivi", de: "Spezial- & Reaktionskleber", fr: "Colles spéciales & réactives", en: "Special & reactive adhesives" },
  stucchi_fughe: { it: "Stucchi per Fughe", de: "Fugenmörtel", fr: "Joints", en: "Grouts" },

  imperm_liquidi: { it: "Impermeabilizzanti Liquidi", de: "Flüssigabdichtungen", fr: "Étanchéité liquide", en: "Liquid waterproofing" },
  malte_elastiche: { it: "Malte Cementizie Elastiche", de: "Elastische Dichtschlämmen", fr: "Mortiers cimentaires élastiques", en: "Elastic cement mortars" },
  teli_accessori: { it: "Teli, Bandelle & Accessori", de: "Dichtbänder & Zubehör", fr: "Bandes & accessoires", en: "Membranes, tapes & accessories" },

  colle_parquet: { it: "Adesivi per Parquet", de: "Parkettklebstoffe", fr: "Colles parquet", en: "Parquet adhesives" },
  colle_pvc_lvt: { it: "Adesivi per PVC, LVT & Moquette", de: "Klebstoffe PVC, LVT & Teppich", fr: "Colles PVC, LVT & moquette", en: "PVC, LVT & carpet adhesives" },
  rasature_specifiche: { it: "Rasature Specifiche", de: "Spezialspachtelmassen", fr: "Enduits spécifiques", en: "Specific smoothing" },

  ripristino_edilizia: { it: "Malte da Ripristino edilizia (R2/R3/R4)", de: "Reparaturmörtel Bau (R2/R3/R4)", fr: "Mortiers de réparation (R2/R3/R4)", en: "Repair mortars (R2/R3/R4)" },
  ripristino_stradale: { it: "Ripristino/riempimento stradale", de: "Strassenreparatur/-verfüllung", fr: "Réparation/remplissage routier", en: "Road repair/filling" },
  protezione_ferri: { it: "Protezione Ferri & Rasanti", de: "Korrosionsschutz & Spachtel", fr: "Protection armatures & enduits", en: "Rebar protection & skim" },
  ancoraggi_sigillanti: { it: "Ancoraggi Chimici & Sigillanti", de: "Chemische Anker & Dichtstoffe", fr: "Ancrages chimiques & mastics", en: "Chemical anchors & sealants" },
};

export function useT(lang) {
  const dict = T[lang] || T.it;
  const t = (k) => dict[k] || k;
  const tc = (id) => (CAT[id] && (CAT[id][lang] || CAT[id].it)) || id;
  return { t, tc };
}

export default T;
